export const EN_JSON = {
    "LABELS": {
      "TERMS_OF_SERVICES": "Terms of Services",
      "TERMS_OF_SERVICE": "Terms of Services",
      "OUR": "Our",
      "SAVE": "Save",
      "PRIVACY_POLICY": "Privacy Policy",
      "GO_TO_BANK": "Go To Bank",
      "CLOSE": "Close",
      "NEFT_PAYMENT_INFO": "To make an offline payment \n login to your banking portal or visit your \n local branch and make a payment to",
      "SELECT_YOUR_BANK": "Select Your Bank",
      "IFSC_CODE": "SWIFT Code",
      "MAKE_PAYMENT_INFO": "To make a payment online, select your desired Bank from the \n list below from \n which you would like to make the payment and click on \"Go to Bank\"",
      "DYNAMIC_VACC_WARNING": "Please note: Consumers are advised to check the dynamic virtual account number generated for the transaction carefully before proceeding to make payments. {{sellerName}} or HDFC Bank or PayEX Technologies shall not be responsible for any payment made in an account other than the dynamic virtual account number generated for respective transaction.",
      "VIRTUAL_ACC_NO": "Dynamic Account Number",
      "LOGIN": "Log in",
      "FORGOT_PIN": "Forgot PIN",
      "SIGN_UP": "Sign Up",
      "THANK_YOU": "Thank you!",
      "PAYMENTS_DUE": "Payments Due",
      "PAYMENT_DUE": "Payment Due",
      "PAYMENTS_HISTORY": "Payments History",
      "PAYMENT_HISTORY": "Payment History",
      "VIEW_CREDIT_NOTES": "View Credits",
      "CREDIT_NOTE": "Credit Note",
      "CREDIT_NOTE_(S)": "Credit Note(s)",
      "SELECT_MULTIPLE_BY": "Select Multiple by:",
      "CREDIT_NOTE_DATE": "Credit Note Date",
      "VIEW_STATEMENT": "Download Statement",
      "VIEW_STATEMENTS": "Download Statement",
      "STATUS": "Status",
      "SELECT_SELLER": "Select Seller",
      "PLEASE_SELECT_COMPANY": "Please Select Company",
      "VIEW_COMPANY_ACCOUNT_STATEMENT": "View Company Account Statement",
      "REQUEST_TO_RECONCILE": "Request to Reconcile",
      "TERMS_AND_CONDITION": "Terms and Condition",
      "OPTIMAL_SELECTION": "Optimal Selection",
      "OLDEST_FIRST": "Oldest first",
      "NO_USABLE_CREDIT": "You don't have any usable credit note at the moment.",
      "YOU_DONT_HAVE_ANY_CN": "There are no available credit note(s) to apply.",
      "DEFERMENT_OF_INVOICE": "Deferment of Invoice(s)",
      "PAY_ADVANCE": "Pay Advance",
      "REGISTER_FOR_IBP": "Register for IBP",
      "MANDATE_MANAGEMENT": "Mandate Management",
      "ASSIGN_LOB": "Assign LOB",
      "HELP_AND_SUPPORT": "Help and Support",
      "ASSIGN_CN_TO_SECURITY_DEPOSIT": "Assign CN to Security Deposit",
      "CHANGE_PIN": "Change PIN",
      "SET_PIN": "Set your PIN",
      "CHANGE_PIN_HEADER": "User PIN",
      "CHANGE_PIN_MESSAGE": "Are you sure you want to change your PIN",
      "REFRESH_CASH_DISCOUNT": "Refresh Cash Discount",
      "CONTACT_US": "Contact Us",
      "HELP": "Help",
      "ENTER_CREDENTIALS_TO_PROCEED": "Please enter your credentials to proceed",
      "VALID_MOBILE_OR_EMAIL": "Please enter a valid mobile number or email",
      "NET_AMOUNT_DUE": "Net Amount Due",
      "CONTINUE": "Continue",
      "SELECT_AT_LEAST_ONE_VID": "Please select at least one VID to enter an amount.",
      "SELECT_ALL": "Select All",
      "CLEAR_ALL": "Clear All",
      "NO_VIDS_FOUND": "No VIDs found for selected invoice. Please enter deduction amount for",
      "AMOUNT_ENTERED_SHOULD_NOT_EXCEED_VID_SELECTION_AMOUNT": "Amount entered should not exceed VID selection amount",
      "VID_SELECTED": "VID(S) Selected",
      "ENTER_DEDUCTION_AMOUNT": "Enter Deduction Amount",
      "AMOUNT_SHOULD_BE_LESS": "Amount should be less than invoice payable amount.",
      "LOG_OUT": "Log Out",
      "FILTER_DUE_DOCUMENTS": "Filter Due Documents",
      "FILTER_PAYMENTS_DUE": "Due Documents",
      "COMPANY": "Company",
      "DOCUMENTS": "Documents",
      "INV": "INV",
      "DN": "DN",
      "DOC": "Doc",
      "DOC_DATE": "Doc Date",
      "NUMBER_OF_DOCUMENTS": "{{noOfDocs}} Document(s)",
      "INR": "INR",
      "CLIENT_NAME": "Client Name",
      "NEFT_RTGS_CREDIT": "NEFT/RTGS Credit",
      "TYPE": "Type",
      "INVOICES": "Invoice(s)",
      "INVOICE": "Invoice",
      "DEBIT_NOTE": "Debit Note(s)",
      "OVERDUES": "Overdues",
      "INVOICE_DATE": "Invoice Date",
      "FROM": "From",
      "TO": "To",
      "CANCEL": "Cancel",
      "CLEAR": "Clear",
      "DONE": "Done",
      "MONTHS": "Months",
      "DATES": "Dates",
      "YEAR": "Year",
      "VIEW_INVOICE": "View Invoice",
      "PAY_INVOICE": "Pay Invoice",
      "CD_RIBBON": "CD Ribbon",
      "CD_AMT": "CD Amount",
      "DUE": "Due",
      "SELECT_WHT_REASON": "Select WHT Reason",
      "WHT_AMOUNT": "WHT Amount",
      "APPLICABLE_CD": "Applicable CD",
      "PAY_INR": "Pay (INR)",
      "AMOUNT": "Amount",
      "ORIGINAL_DOC_AMOUNT": "Original Doc Amount",
      "BALANCE_DOC_AMOUNT": "Balance Doc Amount",
      "BALANCE": "Balance",
      "BAL": "Bal",
      "DUE_ON": "Due On",
      "APPLY_CN": "Apply CN",
      "BANK_AMOUNT": "Bank Amount",
      "PAY_USING": "Pay Using",
      "USING": "Using",
      "PAY_DATE": "Pay Date",
      "Pay_On_Date": "Pay On Date",
      "PAYEX_PIN": "PayEX PIN",
      "REMARKS": "Remarks",
      "BUYER_CODE": "Buyer Code",
      "BACK": "Back",
      "OTHER": "Other",
      "ALREADY_PAID_BY_CHEQUE": "Already Paid By Cheque",
      "ALREADY_PAID_BY_CASH": "Already Paid By Cash",
      "DISPUTED_INVOICE": "Disputed Invoice",
      "OK": "Ok",
      "ENTER_REMARKS": "Enter Remarks",
      "INVOICE_DETAILS": "Invoice Details",
      "FILTER_PAYMENT_HISTORY": "Filter Payment History",
      "FINAL_PAY_AMOUNT": "Net Amount Due",
      "VIEW": "View",
      "CN_APPROVED": "CN Approved",
      "FAILED": "Failed",
      "PAID": "Paid",
      "APPROVED": "Approved",
      "LAST_10_TRANSACTIONS": "Last 10 Transactions",
      "TRANSACTION_DETAILS": "Transaction Details",
      "MIS_NOT_RECEIVED": "MIS Not Received",
      "ENTER_VALID_PIN": "Please Enter valid PIN",
      "CN_PAID": "CN Paid",
      "DOCUMENT_APV_AMOUNT": "Document APV Amount",
      "APV_AMOUNT": "Approved Amount",
      "APV_DATE": "Approved Date",
      "TXN_NO": "TXN No.",
      "DOCUMENT_NOT_FOUND_CONTACT_DISTRIBUTOR": "Document not found, please contact distributor",
      "FROM_DATE": "From Date",
      "AVAILABLE_LIMIT": "Available Limit",
      "ROUND_OFF_AMOUNT": "Round Off Amount",
      "TO_DATE": "To Date",
      "DOWNLOAD": "Download",
      "SELECT_COMPANY": "Select Company",
      "NO_ACTIVE_SCHEDULED_INVOICE_FOUND": "No Active Scheduled Invoice(s) found",
      "REQUEST_DEFERMENT_OF_INVOICES": "Request Deferment of invoice(s)",
      "SELECT_RETAILER": "Select Retailer",
      "SELECT_BANK": "Select Bank",
      "ACCOUNT_NUMBER": "Account Number",
      "NUMBER": "Number",
      "CONFIRM_ACCOUNT_NUMBER": "Confirm Account Number",
      "FOR_THIS_INVOICE": "For This Invoice",
      "PLEASE_NOTE_THAT_WITHHOLDING_AMOUNT": "Please note that you are withholding amount of",
      "CORPORATE_ID": "Corporate ID",
      "DEDUCTION_FOR": "Deduction For",
      "DEDUCTION": "Deduction",
      "USER_ID": "User ID",
      "ALIAS_ID": "Alias ID",
      "MANDATE_REGISTRATION": "Mandate Registration",
      "PENDING": "Pending",
      "DEACTIVATION": "Deactivation",
      "TRACK_IN_VIEW_TRANSACTION": "You can track this in the \"View Outstanding Claims\" section.",
      "CANCELLED": "Cancelled",
      "NEW_REGISTRATION": "New Registration",
      "MANDATE_CANCELLATION": "Mandate Cancellation",
      "MANDATE_REGISTRATION_FORM": "Mandate Registration Form",
      "SELECT_DISTRIBUTION": "Select Distribution",
      "AUTHENTICATION_MODE": "Authentication Mode",
      "BANK_NAME": "Bank Name",
      "CONGRATULATIONS": "Congratulations",
      "CLAIM_NUMBER": "Claim Number",
      "SUCCESSFULLY_RAISED": "has been successfully raised.",
      "ACCOUNT_TYPE": "Account Type",
      "AMOUNT_OF_DEDUCTION": "Amount Of Deduction",
      "NEXT_PAGE": "Next Page",
      "PERSONAL_INFORMATION": "Personal Information",
      "ACCOUNT_HOLDER_NAME": "Account Holder Name",
      "ADDRESS": "Address",
      "MOBILE_NUMBER": "Registered mobile no. or email",
      "EMAIL_ID": "Email ID",
      "SUBMIT": "Submit",
      "CURRENT_PIN": "Current PIN",
      "NEW_PIN": "New PIN",
      "CONFIRM_PIN": "Confirm PIN",
      "CLICK_HERE": "Click Here",
      "SELECTED_AMOUNT": "Selected Amount",
      "SELECTED": "Selected",
      "ENTER_REGISTERED_MOBILE_TO_PROCEED": "Please Enter Your Registered mobile No. And PIN To Proceed.",
      "ENTER_CHEQUE_INFORMATION": "Enter Cheque Information",
      "CONFIRM": "Confirm",
      "UTR": "UTR",
      "DID_NOT_FIND_NEFT_TRANSACTIONS": "We did not find NEFT transaction(s) yet.",
      "DETAILS": "Details",
      "AMOUNT_TO_PAY": "Amount to Pay()",
      "TDS": "TDS",
      "TEST_NOT_REPORTED": "TEST NOT REPORTED",
      "SAMPLE_NOT_BELONG_TO": "SAMPLE NOT BELONG TO",
      "BUILD_TWICE": "BUILD TWICE",
      "WRONG_TEST_REGISTERED": "WRONG TEST REGISTERED",
      "COURIER_CHARGES": "COURIER CHARGES",
      "TOD": "TOD",
      "SLOW_OR_NO_INTERNET": "Slow or No internet connection.",
      "CHECK_INTERNET_SETTINGS": "Please check your internet settings and try again.",
      "SERVER_ISSUE": "There seems to be server issue.",
      "THERE_SEEMS_SERVER_ISSUE": "There seems to be an issue.",
      "TIME_TO_DISCIPLINE_SERVER": "Please give us some time to discipline the server.",
      "PLEASE_TRY_AFTER_SOMETIME": "Please try again after some time.",
      "ENTER_EXISTING_PIN": "Please Enter existing PIN",
      "CONFIRM_PIN_DOES_NOT_MATCH": "Confirm PIN Does Not Match",
      "NO": "No",
      "NO_DATA_FOUND": "No data found, please revise your search.",
      "CLEAR_FILTERS": "Clear Filters",
      "VIEW_DETAILS": "View Details",
      "POSTING_NUMBER": "Posting Number",
      "MULTI_REJECT": "MULTI-REJECT",
      "PAY": "Pay",
      "MULTI_PAY": "MULTI-PAY",
      "REQUEST_TO_PAY": "Request To Pay",
      "PAYMENT_RECEIVED": "Payment Received",
      "PAYMENT_DATE": "Payment Date",
      "PAYMENTS_RECEIVED": "Payments Received",
      "PAYMENTS": "Payments",
      "UTR_NUMBER": "UTR No.",
      "SELECTED_DOCUMENTS": "Selected Documents",
      "INVOICE_AMOUNT": "Invoice Amount",
      "ADVANCE_AMOUNT": "Advance Amount",
      "AMOUNT_ALLOCATED_TO_INVOICES": "Amount Allocated To Invoices",
      "AMOUNT_ALLOCATED_TO_ADVANCE": "Amount Allocated To Advance",
      "STEP_3": "Step 3: Select Credits and Pay",
      "TOTAL": "Total",
      "HIDE_DETAILS": "Hide Details",
      "DATE": "Date",
      "CREDIT_NOTES_PENDING": "Credit Notes - Pending",
      "CREDIT_NOTES_USED": "Credit Notes - Used",
      "ELIGIBLE_CASH_DISCOUNT": "Eligible Cash Discount On Final Payment",
      "OC_NUMBER": "OC Number",
      "TOTAL_DOCS_SELECTED": "Total Docs Selected",
      "TOTAL_PAY_AMOUNT": "Total Pay Amount",
      "CASH_DISCOUNT": "Cash Discount:",
      "CASH_DISCOUNT_AMT": "Cash Discount: {{amt}} ",
      "CASH_DISCOUNT_ON_FINAL_PAYMENT": "Cash Discount On Final Payment",
      "SPECIAL_FREEPAY_DISCOUNT": "Special Freepay Discount",
      "ENTER_VALID_PAY_AMOUNT": "Please Enter A Valid Pay Amount",
      "YOU_ARE_WITHHOLDING_TAX": "You Are Withholding Tax Amount Of",
      "FOR_THIS_PAYMENT": "For This Payment",
      "NO_USABLE_CREDIT_NOTE": "You don't have any usable credit note(s) at the moment.",
      "ONE_OF_CREDIT_NOTE_TO_BE_SPLIT": "One of your credit note selected will be split to balance bank amount.",
      "AVAILABLE_BALANCE": "Available Balance",
      "REJECT": "Dispute Entire Document",
      "SELECTION_DETAILS": "Selection Details",
      "CREDIT_NOTES": "Credit Notes",
      "VIEW_CREDIT_NOTE_NUMBER": "View Credit Note #",
      "PREVIOUS_PAID_DETAILS": "Previous Paid Details",
      "VIEW_APPLIED_CREDIT_NOTE": "View applied Credit Note(s)",
      "PLEASE_WAIT": "Please Wait",
      "NO_RECORDS_FOR_PAYMENT_HISTORY": "No records found for payments history.",
      "INVOICE_NUMBER": "Invoice Number",
      "ENTER_TO_DATE": "Please Enter To Date",
      "ENTER_FROM_DATE": "Please Enter From Date",
      "TOTAL_BALANCE": "Total Balance",
      "REJECT_INVOICE": "Reject Invoice",
      "REJECT_SUB_REASON": "Reject Sub-Reason",
      "REJECT_REASON": "Reject Reason",
      "SELECT_SUB_REASON": "Select Your Sub-Reason",
      "ENTER_VALID_OTHER_SUB_REASON": "Please Enter Valid Other Sub-Reason",
      "PIN_IS_REQUIRED": "PIN Is Required",
      "MOBILE_NUMBER_IS_REQUIRED": "Valid mobile no. or email is required",
      "BY_CONTINUING": "By continuing, you agree to our",
      "TRY_DIFFERENT_NUMBER": "Try a different no. or email",
      "DONT_HAVE_AN_ACCOUNT": "Don't have an account?",
      "ENTER_MOBILE_NUMBER_AND_PIN": "Please enter your registered mobile no. or email, and PIN to proceed",
      "ENTER_REGISTERED_MOBILE_NUMBER": "Please enter your registered mobile no. or email to proceed",
      "ENTER_OTP_SENT_TO": "Please enter OTP sent to your mobile number or email address",
      "TO_PROCEED": "To Proceed",
      "TEST_LANDING_PAGES": "Test Landing Pages",
      "RECEIVED_DATE": "Received Date",
      "AUTO_OFFSET_TIME": "Auto-Offset Time",
      "OFFSET_DOCUMENTS_MANUALLY": "Offset Documents Manually",
      "SORRY_NO_UNASSIGNED_RP": "Sorry, we have not found any un-assigned RP(s).",
      "ASSIGN_TO_SD": "Assign To SD",
      "SELECT_LOB": "Select LOB",
      "RPS_FOUND": "RP(s) found",
      "CLEAR_SELECTION": "Clear Selection",
      "NO_INVOICES_FOUND_FOR_RETAILER": "No Invoices Found.",
      "NO_DATA_FOUND_REVISE_SEARCH": "No data found, please revise your search.",
      "SELECT_CN": "Select CN",
      "SORRY_NO_LOB_FOUND": "Sorry, we have not found any LOB.",
      "TOTAL_CN_AMOUNT_SELECTED_TO_ASSIGN": "Total CN Amount Selected to assign",
      "OTP_IS_REQUIRED": "OTP Is Required",
      "TOTAL_CD": "Total CD",
      "SELECT_BUYER": "Select Buyer",
      "PLEASE_SELECT_BUYER": "Please Select Buyer",
      "PLEASE_SELECT_BANK": "Please Select Bank",
      "ENTER_CORRECT_PAY_AMOUNT": "Please Enter Correct Pay Amount",
      "SELECT_DIVISION": "Select Division",
      "PLEASE_SELECT_DIVISION": "Please Select Division",
      "CN_AMOUNT": "CN Amount",
      "CLEAR_DATES": "Clear Dates",
      "PROCEED": "Continue",
      "PIN": "PIN",
      "OTP": "OTP",
      "GIVE_MISSED_CALL": "Give a Missed Call on",
      "SELECT": "Select",
      "LOWEST_AMOUNT_FIRST": "Lowest Amount First",
      "SELECT_RP_LOB": "Please select RP and LOB.",
      "RPS": "RP (s)",
      "LOBS_ASSIGNED": "LOB(s) assigned successfully.",
      "MANUAL_KNOCK_OFF": "Manual Knock-off",
      "SELLER_CODE": "Seller Code",
      "PAYMENT_ID": "Payment ID",
      "VACC_NUMBER": "VACC No.",
      "OTP_LOGIN_LINK": "OTP Login Link",
      "RETAILER": "Retailer",
      "SELECT_REASON": "Select Reason",
      "WRITE_YOUR_SUPPORT_REQUEST": "write your support request here",
      "SUCCESSFULLY_SAVED_AT": "Successfully saved at",
      "PAYABLE_AMOUNT_ENTERED": "Payable amount entered",
      "CONFIRM_TO_PAY": "Please confirm to pay",
      "CONFIRM_PAYMENT_OF": "Confirm payment of",
      "RE_ENTER_LESSER_VALUE": "Re-enter a lesser value",
      "MORE_THAN_MANDATE_LIMIT": "is more than the mandate limit set",
      "FILE_SUCCESSFULLY_SAVED_AT": "File successfully saved at",
      "PRESS_BACK_AGAIN": "Press back button again to exit the app.",
      "LOGOUT_OF_APP": "Confirm",
      "SELECT_REJECTION_REASON": "Please select rejection reason",
      "FILTER": "Filter",
      "SELLER": "Seller",
      "SELLERS": "Seller(s)",
      "BUYERS": "Buyers",
      "BUYER(S)": "Buyer(s)",
      "DIVISION": "Division",
      "TRAN_NO": "TranNo",
      "TRAN_NO_SEARCH": "TranNumberSearch",
      "FILTER_PAYMENTS": "Filter Payments",
      "CONFIRM_INVOICE_FOR_CD": "Confirm Invoice for CD",
      "SELECT_PARTIAL_PAY_REASON": "Select Partial Pay Reason",
      "ENTER_DEDUCTION_AMT": "Enter Deduction Amount",
      "PARTIAL_PAY_AMOUNT": "Partial Pay Amount",
      "SELECT_DEDUCTION": "Select Deduction(s)",
      "SELECT_REASON_AND_ENTER": "Select reasons and enter a valid amount. Click plus sign to add deductions.",
      "MARKED_ARE_MANDATORY": "(*Marked are mandatory deductions)",
      "SELECT_APPLICABLE_PARTIALPAY_REASON_AND_ENTER": "Select applicable partial pay reason(s), enter a valid amount and click the plus sign to add each required deduction.",
      "INVOICE_NUMBER_SEARCH": "Invoice Number Search",
      "MULTIPAY_TAG": "Multipay Tag",
      "DISCOUNT": "Discount",
      "DUE_TODAY": "Due Today",
      "OVERDUE_MESSAGE": "Overdue By {{days}} day(s)",
      "OVERDUE_BY": "Overdue By",
      "DAY": "day(s)",
      "SWITCH_LANGUAGE": "Switch Language",
      "INVOICE_KNOCK_OFF_MESSAGE": "Total of deductions ({{deductions}}) and paying amount ({{amountPaying}}) should be equal to Invoice Amount ({{invoiceAmount}}). <p>{{remark}}</p>",
      "INVOICE_EXCEEDING_MESSAGE": "Amount paying exceeds invoice amount by ({{amount}})",
      "INVOICE_DECREASING_MESSAGE": "There is difference of amount ({{amount}})",
      "CASH_DISCOUNT_TEXT": "Cash Discount on final payment",
      "SEARCH_INVOICE": "Search by Invoice Number",
      "SEARCH_BY_DOC_NO": "Search by Document Number",
      "SEARCH_BY_TRAN_NO": "Search by Transaction Number",
      "VIEW_DOCUMENT": "View Document",
      "FILTER_OUTSTANDING": "Filter Outstanding",
      "RESET": "Reset",
      "NEFT_BALANCE": "NEFT Balance",
      "CREDIT": "CREDIT",
      "DOWNLOAD_FILE": "Upload File",
      "CONFIRM_PIN_NOT_MATCH": "Confirm PIN do not match",
      "YOUR_CONFIRM_PIN_NOT_MATCH": "Your PINs do not match",
      "DUE_DATE": "Due Date",
      "VIEW_RECONCILLIATION": "View Request To Reconcile",
      "VIRTUAL_ACCOUNT": "Virtual Account",
      "OFFSET_INVOICES": "Offset Invoices",
      "NO_RTR_DATA_FOUND": "No RTR Data Found",
      "NEW_DOWNLOAD_FILE": "Download File",
      "APPROVED_REJECTIONS": "Approved Rejections",
      "REJECTION_APPROVAL_PENDING": "Rejection Approval Pending",
      "NO_REJECTION_APPROVAL_DONE": "It seems you have not done any Rejection approval.",
      "NO_REJECTION_APPROVALS": "No more rejected invoices available for you.",
      "NO_REJECTION_APPROVALS_TRANSACTIONS": "No more transactions available.",
      "ORIGINAL_DOC_AMT": "Original Doc Amount",
      "DOC_NO": "Doc No.",
      "INV_DATE": "Inv Date",
      "REJECT_DATE": "Reject Date",
      "REJECTION_APPROVED": "Rejection Approved",
      "APPROVE": "Approve",
      "CONFIRM_APPROVAL": "Please confirm Approval.",
      "CONFIRM_REJECTION": "Please confirm Rejection.",
      "REJECTED": "Rejected",
      "REJECTION_APPROVAL": "Rejection Approval",
      "WELCOME": "Welcome",
      "PLEASE_CHANGE_YOUR_PIN_FIRST": "Please change your PIN first to access the app.",
      "PLEASE_SET_YOUR_PIN_FIRST": "Please set your PIN first to access the app.",
      "PLEASE_UPDATE_YOUR_PIN_FIRST": "please update your PIN to proceed.",
      "YES_LOG_ME_OUT": "OK",
      "PO_NO": "PO No",
      "SELECT_ADVANCE_PAY_TYPE": "Select Advance Pay Type",
      "YOU_HAVE_ENTERED_AN_INCORRECT_PIN": "You have entered an incorrect pin and made",
      "UNSUCCESSFUL_ATTEMPTS": "unsuccessful attempt(s).",
      "PLEASE_RESET_YOUR_PIN_TO_PROCEED": "Please reset your pin to proceed.",
      "NO_SEARCH_FILTER_RESULT": "No documents found for selected filters.",
      "PO_REF_NO": "PO/Ref No",
      "SUCCESS": "Success",
      "UNPAID": "UNPAID",
      "EXT_SETTLED": "EXT SETTLED",
      "FULLY_PAID": "Fully Paid",
      "UNUSED": "UNUSED",
      "USED": "USED",
      "UNKNOWN_PAYMENT": "UNKNOWN PAYMENT",
      "SECURITY_DEPOSIT": "SECURITY DEPOSIT",
      "AWAITING_MIS": "AWAITING MIS",
      "CN": "CN",
      "APPROVAL_PENDING": "Approved",
      "REJECTBTN": "Reject",
      "NO_REJECTION_APPROVALS_PENDING": "No more transaction available for you.",
      "PAY_ON_DATE": "Pay On Date",
      "SCHEDULED_DATE": "Scheduled Date",
      "AP": "AP",
      "S": "S",
      "M": "M",
      "TRANSACTION_TYPE": "Transaction Type",
      "ACTION": "Action",
      "SINGLE": "Single",
      "MULTIPLE": "Multiple",
      "ADVANCE": "Advance",
      "DOC_AMOUNT": "Doc Amount",
      "WITHHOLDING_TAX": "Withholding Tax",
      "PAID_AMOUNT": "Paid Amount",
      "DEDUCTION_REASONS": "Deduction Reasons",
      "SEARCH_BY_TRANSACTION_NO_NEW": "Search by Transaction No",
      "SEARCH_BY_DOC_NO_NEW": "Search by Doc Number",
      "DISPUTE_ENTIRE_INVOICE": "Dispute Entire Invoice",
      "CVV": "CVV",
      "PRICE_DIFFERENCE": "Price Difference",
      "SHORT_MATERIAL_RECEIPT": "Short Material Receipt",
      "EXCESS_BILLING_AGAINST_PO": "Excess Billing against PO",
      "MATERIAL_RECEIVED_IN_DAMAGED_CONDITION": "Material Received in damaged condition",
      "WRONG_BILLING": "Wrong billing",
      "DISCOUNT_RELATED_ERRORS": "Discount Related Errors",
      "ADJUSTED_AGAINST_CREDIT_NOTE_OUTSIDE_APPLICATION": "Adjusted against Credit Note outside application",
      "ANY_OTHER_REASON": "Any other reason",
      "REASON_FOR_PARTIAL_PAYMENT": "Reason for Partial Payment",
      "ENTER_DEDUCTION_AMOUT": "Enter Deduction Amout",
      "SELECT_CREDIT_NOTE(S)": "Select Credit Note(s)",
      "GO_TO_DISPUTE_ENTIRE_INVOICE_WINDOW": "Go to Dispute Entire Invoice window",
      "SELECTED_DOCUMENT(S)_DETAILS": "Selected document(s) details",
      "SELECT_YOUR_REASON": "Select Your Reason",
      "DN_DETAILS": "DN Details",
      "FIS_PRIVATE_LIMITED": "FIS Private Limited",
      "VIEW_CREDITS_PENDING": "View Credits - Pending",
      "DOC_NUMBER": "Doc Number",
      "DUE_AMOUNT": "Due Amount",
      "SELECT_REASONS_AND_ENTER_A_VALID_AMOUNT_CLICK_PLUS_SIGN_TO_ADD_DEDUCTIONS": "Select reasons and enter a valid amount. Click plus sign to add deductions.",
      "REJECT_INVOICES": "Reject Invoices",
      "YOU_HAVE_ENTERED_AN_INCORRECT_TRANSACTION PIN AND MADE": "You have entered an incorrect transaction PIN and made",
      "VERSION_INFO": "version Info",
      "PLEASE_ENTER_OTP_SENT_TO": "Please enter OTP  sent to {{mobileNo}}",
      "TRANSACTION_NO": "Transaction No.",
      "TRANSACTION_DATE": "Transaction Date",
      "TRANSACTION_TOTAl": "Transaction Total",
      "SEARCH_BY_DOC_NUMBER_OR_TRANSACTION_NO": "Search by Doc Number or Transaction No.",
      "DOCUMENT(S)": "Document(s)",
      "PLEASE_CALL_US_AT_XXX": "Please call us at xxx",
      "COMING_SOON": "Coming Soon",
      "YES,_LOG_ME_OUT": "Yes, Log me out",
      "INVALID_OTP": "Invalid OTP",
      "SORRY_YOUR_MOBILE _NUMBER_IS_NOT_REGISTERED_WITH_US": "Sorry, your mobile number is not registered with us. Please contact your Seller.",
      "INVALID_USERNAME_OR_PASSWORD": "Invalid username or password",
      "YOU_HAVE_ENTERED_AN_INCORRECT_PIN_AND_MADE_3_UNSUCCESSFUL_ATTEMPT": "You have entered an incorrect pin and made 3 unsuccessful attempt(s).Please reset your pin to proceed.",
      "YOU_HAVE_ENTERED_THE_WRONG_PIN._PLEASE_RE-ENTER": "You have entered the wrong PIN. Please re-enter.",
      "YOUR_SESSION_IS_INVALID/EXPIRED_PLEASE_LOG_IN_AGAIN": "Your Session is invalid/expired! Please log in again",
      "ARE_YOU_SURE_YOU_WANT_TO_LOG_OUT": "Are you sure you want to log out?",
      "YOUR_CURRENT_PIN_IS_INCORRECT_PLEASE_ENTER_YOUR_CURRENT": "Your Current PIN is incorrect. Please enter your current PIN",
      "PLEASE_ENTER_PIN_TO_LOG_IN": "Please enter PIN to log in",
      "PLEASE_ENTER_A_VALID_MOBILE_NO_OR_EMAIL_TO_LOGIN": "Please enter a valid mobile no. or email to login.",
      "PLEASE_ENTER_YOUR_CREDENTIALS_TO_PROCEED": "Please enter your credentials to proceed",
      "SELECT_CURRENCY": "Select Currency",
      "DATE_RANGE": "Date Range",
      "PLEASE_SELECT_DATE_RANGE": "Please Select Date Range",
      "SELECT_DOC_TYPE": "Select Doc Type",
      "SELECT_STATUS": "Select Status",
      "PAYMENT_METHOD": "Payment Method",
      "SELECT_PAYMENT_METHOD": "Select Payment Method",
      "PLEASE_ENTER_CVV_FOR_CARD": "Please enter CVV for Card",
      "DD-MM-YYYY": "dd-mm-yyyy",
      "YOU_HAVE_ENTERED_AN_INCORRECT_TRANSACTION_PIN_AND_MADE_1_UNSUCCESSFUL_ATTEMPT(S)": "You have entered an incorrect transaction PIN and made {{countOfIncorrectPinEntered}} unsuccessful attempt(s).Please enter correct transaction PIN.",
      "PAYMENT_AMOUNT": "Payment Amount",
      "PLEASE_ENTER_VALID_PIN": "Please Enter valid PIN",
      "PLEASE_ENTER_CORRECT_PAY_AMOUNT": "Please Enter Correct Pay Amount",
      "PLEASE_SELECT_SELLER": "Please Select Seller",
      "PLEASE_SELECT_CURRENCY": "Please Select Currency",
      "PLEASE_CONFIRM_TO_PAY": "Please confirm to Pay",
      "PLEASE_SELECT_ADVANCE_PAY_TYPE": "Please select Advance Pay Type",
      "ADD_NEW_CARD": "Add New Card",
      "ADD_NEW_CHECK": "Add New Check",
      "CARD_TYPE": "Card Type",
      "CARD_NO": "Card No.",
      "CARDHOLDERS_NAME": "Cardholder's Name",
      "EXPIRATION": "Expiration",
      "ACTIONS": "Actions",
      "ACTIVE": "Active",
      "INACTIVE": "Inactive",
      "ACTIVATE_CARD": "Activate Card",
      "DEACTIVATE_CARD": "Deactivate Card",
      "CONFIRM_CARD_UPDATE": "Confirm Card Update",
      "SELECT_CARD": "Select Card",
      "CARD_NUMBER": "Card Number",
      "EXPIRATION_DATE": "Expiration Date",
      "CARDHOLDER_NAME": "Cardholder Name",
      "PLEASE_ENTER_3_OR_4_DIGITS": "Please Enter 3 or 4 digits",
      "ALL_BELOW_FIELDS_ARE_REQUIRED": "All below fields are required.",
      "PLEASE_ENTER_A_CARD_NUMBER": "Please enter a card number",
      "PLEASE_ENTER_A_VALID_CARD_NUMBER": "Please enter a valid card number",
      "PLEASE_ENTER_A_VALID_EXPIRATION_DATE": "Please enter a valid expiration date",
      "PLEASE_ENTER_THE_CARD_HOLDER_NAME": "Please enter the card holder name",
      "YOUR_CARD_DETAILS_HAVE_BEEN_CAPTURED_SUCCESSFULLY": "Your Card Details have been captured successfully",
      "ARE_YOU_SURE_YOU_WANT_TO_ACTIVATE_THIS_CARD": "Are you sure you want to activate this card?",
      "CARD_UPDATED_SUCCESSFULLY": "Card Updated Successfully",
      "ARE_YOU_SURE_YOU_WANT_TO_DEACTIVATE_THIS_CARD": "Are you sure you want to deactivate this card?",
      "DOCUMENT_DATE": "Document Date",
      "GET_2.5%_CD_BY_6TH_DEC_2022": "Get 2.5% CD by 6th Dec 2022",
      "OVERDUE_BY_2_DAYS": "overdue by 2 days",
      "SHOWING_1_TO_10_OF_26_DOCUMENTS": "Showing 1 to 10 of 26 documents",
      "VIEW_PAYMENTS_HISTORY": "View Payments History",
      "CURRENCY": "Currency",
      "DEBITNOTE": "DEBIT NOTE",
      "MM_DD_YY": "MM-DD-YY",
      "CHANGE_USER_PIN": "Change User PIN",
      "ADD_NEW_ECHECK": "Add New eCheck",
      "MERCHANT_ID": "Merchant ID",
      "NAME_ON_ACCOUNT": "Name On Account ",
      "PAYMENT_OPTION": "Payment Option",
      "ROUTING_NUMBER": "Routing Number",
      "ACTIVATE_CHECK": "Activate Check",
      "DEACTIVATE_CHECK": "Deactivate Check",
      "CONFIRM_ECHECK_UPDATE": "Confirm eCheck Update",
      "ARE_YOU_SURE_YOU_WANT_TO_DEACTIVATE_THIS_CHECK?": "Are you sure you want to deactivate this check?",
      "CHECK_UPDATED_SUCCESSFULLY": "Check updated successfully",
      "THERE_ARE_CURRENTLY_NO_AVAILABLE_DOCUMENT": "There are currently no available Document(s).",
      "MANAGE_PAYMENT_METHOD": "Manage Payment Method",
      "MANAGE_AUTO_PAY": "Manage Auto Pay",
      "HOME": "Home",
      "TOTAL_OUTSTANDING": "Total Outstanding",
      "TOTAL_DUE_INVOICE": "Total Due - Invoices",
      "TOTAL_DUE_INVOICE_DEBITNOTES": "Total Due - Debit Notes",
      "TOTAL_OUTSTANDING_INVOICE": "Total Outstanding - Invoices",
      "TOTAL_OUTSTANDING_INVOICE_DEBITNOTES": "Total Outstanding - Debit Notes",
      "CREDITS": "Credits",
      "NET_RECEIVABLES": "Net Receivables",
      "LEDGER_INVOICE_STATUS": "Ledger Invoice Status",
      "PERCENTAGE_OF_AR": "Percentage of A/R",
      "LEDGER_AMT": "Ledger Amt",
      "OUTSTANDING_AR_SNAPSHOT": "Outstanding A/R Snapshot",
      "AR_HEALTH": "A/R Health",
      "TOTAL_DOCUMENT_AMT": "Total Document(s) Amt",
      "PAID_BEFORE_DUE": "Paid Before Due",
      "PAID_ON_DUE": "Paid On Due",
      "PAID_AFTER_DUE": "Paid After Due",
      "OVERDUE": "Overdue",
      "CURRENT_LIVE_HEALTH": "Current Collection Health",
      "DOCUMENT_AGE": "Document(s) Age",
      "COUNT_OF_DOCUMENTS": "Count of Document(s)",
      "YTD_PAID_HEALTH": "YTD Paid Health",
      "PAYMENT_AGE": "Payment Age",
      "TOTAL_AMOUNT": "Total Amount",
      "DOCUMENT_SUMMARY": "Document Summary",
      "ABOUT": "About",
      "TOTAL_COUNT": "Total Count",
      "DOCUMENT_PAID_TODAY": "Document(s) paid today",
      "DOCUMENT_APPROVED_TODAY": "Document(s) approved today",
      "DOCUMENT_PAID_THIS_MONTH": "Document(s) paid this month",
      "TOTAL_PENDING_DOCUMENTS": "Total pending Document(s)",
      "TOTAL_PAID_DOCUMENTS": "Total paid Document(s)",
      "TOTAL_OVERDUE_DOCUMENTS": "Total overdue Document(s)",
      "RECON_SNAPSHOT": "Recon Snapshot",
      "WELCOME_TO_FIS_EIPP": "Welcome to FIS EIPP 360 - Buyer Portal",
      "MAXIMUM_EFFICIENCY_WITH": "Maximize efficiency with a 360 degree view of all invoice and payment activities.",
      "DOC_AMT": "Doc Amt.",
      "DUE_AMT": "Due Amt.",
      "MANAGE_CARDS": "Manage Cards",
      "MANAGE_ECHECKS": "Manage eChecks",
      "WOULD_YOU_LIKE_TO_DISPUTE_ENTIRE_DOCUMENTS": "Would you like to dispute the entire document(s)?",
      "YOU_HAVE_ENTERED_INCORRECT_PIN": "You have entered an incorrect PIN and your transaction was unable to be processed. Click OK below to re-enter your PIN.",
      "YOU_HAVE_ENTERED_AN_INCORRECT_TRANSACTION": "You have an incorrect transaction PIN and made",
      "PLEASE_REENTER_TO_PROCEED": "Please re-enter to proceed.",
      "PAYMENT_REF": "Payment Ref",
      "VIEW_PAYMENT_DUES": "View Payments Due",
      "VIEW_CREDIT_USED": "View Credits - Used",
      "PAUSE": "Pause",
      "DELETE": "Delete",
      "NEW_AUTOPAY_SCHEDULE": "New Auto Pay Schedule",
      "SELECT_DATA_TYPE": "Select Data Type",
      "PLEASE_ENTER_YOUR_CVV": "Please enter your CVV",
      "YOU_HAVE_ENTERED_AN_INCORRECT_PIN_PLEASE_RE_ENTER_TO_PROCEED": "You have entered an incorrect PIN. Please re-enter to proceed.",
      "PAYMENT_SUCCESSFUL": "Payment Successful",
      "CONFIRM_PAYMENT_OF_AMT": "Confirm payment of {{amt}}",
      "YOU_HAVE_ENTERED_AN_INCORRECT_PIN_AND_MADE_3_UNSUCCESSFUL_ATTEMPT_PLEASE_RESET_YOUR_PIN_TO_PROCEED": "You have entered an incorrect PIN and made {{countOfIncorrectPinEntered}} unsuccessful attempt(s). Please reset your PIN to proceed.",
      "ELIGIBLE_FOR_PER_CASH_DISCOUNT_AMT_BY_DATE": "Eligible for {{per}} cash discount ({{amt}}) through {{date}}",
      "JANUARY": "January",
      "FEBRUARY": "February",
      "MARCH": "March",
      "APRIL": "April",
      "MAY": "May",
      "JUNE": "June",
      "JULY": "July",
      "AUGUST": "August",
      "SEPTEMBER": "September",
      "OCTOMBER": "October",
      "NOVEMBER": "November",
      "DECEMBER,": "December",
      "DECEMBER": "December",
      "ACTIVATE": "Activate",
      "DEACTIVATE": "Deactivate",
      "RESUME": "Resume",
      "CREATE_NEW_AUTO_PAY_SCHEDULE": "Create New Auto Pay Schedule",
      "DASHBOARD": "Dashboard",
      "ADD_ATTACHMENT": "Add Attachment",
      "WELCOME!": "Welcome!",
      "LOGOUT": "Logout",
      "BUYER_PORTA_>_DASHBOARD": "Buyer Portal > Dashboard",
      "SETTLED_OUTSIDE": "Settled Outside",
      "PARTIALLY_PAID": "Partially Paid",
      "OUTSTANDING_A/R_SNAPSHOT_(To_100)": "Outstanding A/R Snapshot (Top 100)",
      "NOT_YET_PAST_DUE": "Not yet past due",
      "1-30_DAYS_PAST_DUE": "1-30 days past due",
      "1-8_DAYS_PAST_DUE": "1-8 days past due",
      "9-30_DAYS_PAST_DUE": "9-30 days past due",
      "31-60_DAYS_PAST_DUE": "31-60 days past due",
      "61-90_DAYS_PAST_DUE": "61-90 days past due",
      "91-120_DAYS_PAST_DUE": "91-120 days past due",
      "121-150_DAYS_PAST_DUE": "121-150 days past due",
      "151-180_DAYS_PAST_DUE": "151-180 days past due",
      ">_180_DAYS_PAST_DUE": "> 180 days past due",
      "TOTAL_DUES": "Total Dues",
      "PAID_EARLY": "Paid Early",
      "PAID_ON_DUE_DATE": "Paid on due date",
      "PAID_WITHIN_1-30_DAYS_PAST_DUE": "Paid within 1-30 days past due",
      "PAID_WITHIN_1-8_DAYS_PAST_DUE": "Paid within 1-8 days past due",
      "PAID_WITHIN_9-30_DAYS_PAST_DUE": "Paid within 9-30 days past due",
      "PAID_WITHIN_31-60_DAYS_PAST_DUE": "Paid within 31-60 days past due",
      "PAID_WITHIN_61-90_DAYS_PAST_DUE": "Paid within 61-90 days past due",
      "PAID_WITHIN_91-120_DAYS_PAST_DUE": "Paid within 91-120 days past due",
      "PAID_WITHIN_121-150_DAYS_PAST_DUE": "Paid within 121-150 days past due",
      "PAID_WITHIN_151-180_DAYS_PAST_DUE": "Paid within 151-180 days past due",
      "PAID_AFTER_180_DAYS_PAST_DUE": "Paid after 180 days past due",
      "CLEAR_DATE": "Clear Date",
      "SHOWING_1_TO 10 OF 17 DOCUMENTS": "Showing 1 to 10 of 17 documents",
      "SHOWING_OUT_OF_DOCUMENTS": "Showing {{start}} to {{end}} of {{total}} documents",
      "N_DOC(S)": "n Doc(s)",
      "DISCOUNT_%": "Discount %",
      "DISCOUNT_AMT": "Discount Amt.",
      "YOU_HAVE_ENTERED_AN_INCORRECT_TRANSACTION_PIN_AND_MADE_1_UNSUCCESSFUL_ATTEMPT(S).PLEASE_ENTER_CORRECT_TRANSACTION_PIN.": "You have entered an incorrect transaction PIN and made 1 unsuccessful attempt(s).Please enter correct transaction PIN.",
      "DISPUTE_REASON(S)": "Dispute Reason(s)",
      "M/S/A_TAG": "M/S/A tag",
      "SHOWING_1_TO_2_OF_2_DOCUMENTS": "Showing 1 to 2 of 2 documents",
      "EXPIRED": "Expired",
      "ALL_FIELDS_ARE_REQUIRED": "All fields are required.",
      "SELECT_A_CURRENCY": "Select a Currency",
      "EXPIRATION_DATE[MONTH_|_YEAR]": "Expiration Date[month | year]",
      "CVV_MUST_BE_3_OR_4_DIGITS": "CVV must be 3 or 4 digits",
      "CARD_ADDED_SUCCESSFULLY._PLEASE_NOTE_THAT_DEPENDING_ON_YOUR_CARD_NETWORK,_THERE_MAY_BE_A_TEMPORARY_TRANSACTION_HOLD_PLACED_ON_THE_CARD.": "Card added successfully. Please note that depending on your card network, there may be a temporary transaction hold placed on the card.",
      "CARD_ALREADY_IN_USE": "Card already in use",
      "CONFIRM_ACCOUNT_UPDATE": "Confirm Account Update",
      "ACCOUNT_UPDATE": "Account Update",
      "ACCOUNT_UPDATED_SUCCESSFULLY": "Account Updated Successfully",
      "ARE_YOU_SURE_YOU_WANT_TO_ACTIVATE_THIS_CHECK": "Are you sure you want to activate this check",
      "PLEASE_ENTER_THE_ACCOUNT_NUMBER": "Please enter the account number",
      "PLEASE_ENTER_THE_ROUTING_NUMBER": "Please enter the routing number",
      "PLEASE_ENTER_THE_BANK_NAME": "Please enter the bank name",
      "PLEASE_ENTER_THE_NAME_ON_THE_ACCOUNT": "Please enter the name on the account",
      "YOUR_CHECK_DETAILS_HAVE_BEEN_CAPTURED_SUCCESSFULLY.": "Your check details have been captured successfully.",
      "ACCOUNT_NUMBER_ALREADY_IN_USE.": " Account Number already in use.",
      "FOUND_AUTO_PAY_SCHEDULES": "Found {{count}} auto pay schedule(s)",
      "SCHEDULE": "Schedule",
      "INFO": "Info",
      "ARE_YOU_SURE_YOU_WANT_TO_ACTIVATE_THE_SCHEDULING_PROCES?": "Are you sure you want to activate the scheduling process?",
      "SCHEDULE_UPDATE": "Schedule Update",
      "ARE_YOU_SURE_YOU_WANT_TO_DEACTIVATE_YOUR_SCHEDULE?": "Are you sure you want to deactivate your schedule?",
      "PLEASE_NOTE_THAT_YOUR_SCHEDULE_IS_DEACTIVATED": "Please note that your schedule is deactivated",
      "ARE_YOU_SURE_YOU_WANT_TO_DELETE_YOUR_SCHEDULE": "Are you sure you want to delete your schedule",
      "SCHEDULE_DELETION": "Schedule Deletion",
      "SCHEDULE_DELETED_SUCCESSFULLY.": "Schedule deleted successfully.",
      "THERE_ARE_NO_AUTO_PAY_SCHEDULES_CONFIGURED.": "There are no auto pay schedules configured.",
      "THIS_PAYMENT_SCHEDULE_CANNOT_BE_ACTIVATED_BECAUSE_THE_PAYMENT_METHOD_IS_EITHER_EXPIRED_OR_INACTIVE.": "This payment schedule cannot be activated because the payment method is either expired or inactive.",
      "SELLER_AND_PAYMENT_METHOD_SELECTION": "Seller and Payment Method Selection",
      "NO_DATA_FOUND_FOR_THE_SELECTED_PAYMENT_METHOD": "No data found for the selected payment method.",
      "ENTER_SCHEDULE_DETAILS": "Enter Schedule Details",
      "SELECT_SCHEDULE_TYPE": "Select Schedule Type",
      "AUTOPAY_(X)_NUMBER_OF_DAYS_BEFORE_DUE_DATE": "Autopay (x) number of days before due date",
      "WEEKLY": "Weekly",
      "MONTHLY": "Monthly",
      "ALL_THE_DOCUMENTS_OVERDUE,_OR_DUE_ON_OR_BEFORE_(X)_DAYS_WILL_BE_AUTO_PAID.": "All the documents overdue, or due on or before (x) days will be auto paid.",
      "SELECT_THE_NO._OF_DAYS_TO_THE_DUE_DATE_TO_CONSIDER_FOR_AUTO_PAYMENT.": "Select the no. of days to the due date to consider for auto payment.",
      "ENTER_THE_AMOUNT_LIMIT,_OR_LEAVE_BLANK_FOR_NO_LIMIT.": "Enter the amount limit, or leave blank for no limit.",
      "TRANSACTION": "Transaction",
      "OUTSTANDING": "Outstanding",
      "APPLY": "Apply",
      "PLEASE_SELECT_A_BUYER": "Please Select A Buyer",
      "PLEASE_SELECT_A_CURRENCY": "Please Select A Currency",
      "ENTER_PAYMENT_AMOUNT": "Enter Payment Amount",
      "PIN_UPDATE": "PIN Update",
      "PLEASE_CALL_US_AT_0330_134_8830": "Please call us at 0330 134 8830",
      "YOU_HAVE_ENTERED_AN_INCORRECT_PIN_AND_MADE_4_UNSUCCESSFUL_ATTEMPT(S)._PLEASE_RESET_YOUR_PIN_TO_PROCEED.": "You have entered an incorrect PIN and made 4 unsuccessful attempt(s). Please reset your PIN to proceed.",
      "WELCOME_TO_FIS_EIPP_360_-_BUYER_PORTAL_MAXIMIZE_EFFICIENCY_WITH_A_360_DEGREE_VIEW_OF_ALL_INVOICE_AND_PAYMENT_ACTIVITIES.": "Welcome to FIS EIPP 360 - Buyer Portal Maximize efficiency with a 360 degree view of all invoice and payment activities.",
      "SORRY,_YOUR_MOBILE_NUMBER_IS_NOT_REGISTERED_WITH_US._PLEASE_CONTACT_YOUR_SELLER_OR_RELATIONSHIP_MANAGER.": "Sorry,your mobile number is not registered with us. Please contact your Seller or Relationship Manager.",
      "CARD_UPDATE": "Card Update",
      "PLEASE_NOTE_THAT_YOUR_SCHEDULE_IS_ACTIVATED": "Please note that your schedule is activated",
      "DESCRIPTIVE_TEXT_FOR_AUTO_PAY_SCHEDULE": "Descriptive text for auto pay schedule",
      "NEXT": "Next",
      "SELLER_AND_PAYMENT_METHOD_SUMMARY": "Seller and Payment Method Summary",
      "ECHECK_DETAILS": "eCheck Details",
      "DESCRIPTIVE_TEXT_FOR_AUTO_PAY_SCEDULE": "Descriptive text for auto pay scedule",
      "SUNDAY": "Sunday",
      "MONDAY": "Monday",
      "TUESDAY": "Tuesday",
      "WEDNESDAY": "Wednesday",
      "THURSDAY": "Thursday",
      "FRIDAY": "Friday",
      "SATURDAY": "Saturday",
      "ALL_THE_DUE_AND_OVERDUE_DOCUMENTS_WILL_BE_PAID_ON_SELECTED_DAYS_OF_THE_MONTH": "All the due and overdue documents will be paid on selected days of the month.",
      "ENTER_COMMA_SEPERATED_DAYS_OF_THE_MONTH": "Enter comma-separated days of the month(e.g., 1,15,31). Invalid days will be ignored.",
      "INCLUDE_LAST_DAY_OF_THE_MONTH": "Include last day of the month",
      "CARD_DETAILS": "Card Details",
      "REVIEW_AND_SAVE": "Review and Save",
      "AUTO_PAY_SCHEDULE_SUMMARY": "Auto Pay Schedule Summary",
      "SCHEDULE_TYPE": "Schedule Type",
      "AMOUNT_LIMIT": "Amount Limit",
      "SELECTED_DAYS": "Selected Days",
      "MONTHLY_ON_EVERY_15,30_OF_EACH_MONTH": "Monthly on every 15,30 of each month",
      "DAYS_OF_THE_MONTH": "Days of the Month",
      "PLEASE_CONFIRM": "Please Confirm",
      "WEEKLY_ON_EVERY_SUNDAY,_AND_SATURDAY_OF_EACH_WEEK": "Weekly on every Sunday, and Saturday of each week",
      "AUTO_PAY_DAYS_BEFORE_DUE_DATE": "Auto pay {{days}} day(s) before due date",
      "SAVE_AUTO_PAY_SCHEDULE": "Save auto pay schedule",
      "PLEASE_ENTER_CORRECT_USERNAME_OR_PASSWORD": "Please Enter Correct Username Or Password",
      "PLEASE_ENTER_A_VALID_MOBILE_NUMBER_OR_EMAIL": "Please enter a valid mobile number or email.",
      "ENTER_YOUR_CVV": "Enter Your CVV",
      "Save": "Save",
      "MONTHLY_ON_EVERY_15_30_OF_EACH_MONTH": "Monthly on every 15,30 of each month",
      "WEEKLY_ON_EVERY_SUNDAY_AND_SATURDAY_OF_EACH_WEEK": "Weekly on every Sunday, and Saturday of each week",
      "AUTO_PAY_1_DAYS_BEFORE_DUE_DATE": "Auto pay 1 day(s) before due date",
      "AUTO_PAY_2_DAYS_BEFORE_DUE_DATE": "Auto pay 2 day(s) before due date",
      "AUTO_PAY_3_DAYS_BEFORE_DUE_DATE": "Auto pay 3 day(s) before due date",
      "AUTO_PAY_4_DAYS_BEFORE_DUE_DATE": "Auto pay 4 day(s) before due date",
      "AUTO_PAY_5_DAYS_BEFORE_DUE_DATE": "Auto pay 5 day(s) before due date",
      "BUYER": "Buyer",
      "BUYER_PORTAL": "Buyer Portal",
      "SELECT_DAYS_OF_WEEK": "Select days of week",
      "ALL_THE_DUE_AND_OVERDUE_DOCUMENTS_WILL_BE_PAID_ON_SELECTED_DAYS_OF_THE_WEEK": "All the due and overdue documents will be paid on selected days of the week.",
      "OVERDUE_RIBBON": "Overdue ribbon",
      "PAY_DUES": "Pay Dues",
      "WITHDHOLDING_TAX": "Withdholding Tax",
      "PLEASE_CALL_US_AT": "Please call us at",
      "CUSTOMER": "customer",
      "CASH_DISCOUNT_FORMATED": "Cash Discount: {{per}}% AMT. {{amt}}",
      "OK_BUTTON": "OK button",
      "PLEASE_ENTER_OTP_SENT_TO_0209060502": "Please enter OTP sent to 0209060502",
      "TRANSACTIONS": "Transactions",
      "MANAGE_PAYMENT_METHODS": "Manage Payment Methods",
      "DOWNLOAD_STATEMENTS": "Download Statements",
      "DOCUMENT(S)_PAID_TODAY": "Document(s) paid today",
      "DOCS": "Doc(s)",
      "BROWSE": "Browse",
      "EXPIRES_IN_DAYS": "Expires in {{days}} days",
      "ATTACHMENT": "Attachment",
      "REASON": "Reason",
      "CREDIT_CARD": "Credit Card",
      "ECHECK": "eCheck",
      "OOPS": "Oops!",
      "UPDATE": "UPDATE",
      "ON_EVERY_EACH_WEEK": "on every {{week}} of each week",
      "AND": "and",
      "ON_EVERY_EACH_MONTH": "on every {{month}} of each month",
      "NOT_APPLICABLE": "NA",
      "INVALID_DATE_TO_INVALID_DATE": "Invalid date to Invalid date",
      "FROM_DATE_TO_DATE": "{{from}} to {{to}}",
      "PLEASE_ENTER_REMARK": "Please enter remark",
      "ENTER_WHT_AMOUNT": "Enter WHT Amount",
      "PROCEED_TO_PAY": "Proceed To Pay",
      "FOC": "FOC",
      "SELECT_SAVED_CARD_FOR_PAYMENT": "Select saved card for payment",
      "PAYMENT_COMPLETED_SUCCESSFULLY": "Payment Completed Successfully",
      "WIRE_TRANSFER": "Wire Transfer",
      "INVOICE_PAY_QA_CODE": "Invoice-Pay QR Code",
      "ABOUT_US": "About Us",
      "ADMIN_HEAD": "Admin Head",
      "NAVIGATION": "Navigation",
      "NOTIFICATION": "Notification",
      "SELECT_OR_DRAG_JSON_FILE_FOR": "Select or Drag JSON file for",
      "MAKE_MANUAL_OFFSET": "Make Manual Offset",
      "PAYMENT_TRANSFER": "Payment Transfer",
      "SOURCE": "Source",
      "TIME": "Time",
      "SUGGESTED_ACTIONS": "Suggested Actions",
      "FILTERS": "Filters",
      "MOVE_TO": "Move To",
      "LABEL_AS": "Label as",
      "UPDATES": "Updates",
      "SOCIAL": "Social",
      "PROMOTIONS": "Promotions",
      "FORUMS": "Forums",
      "MORE_OPTION": "More Option",
      "MARK_AS_UNREAD": "Mark as Unread",
      "ADD_TO_TASKS": "Add to Tasks",
      "ADD_STAR": "Add Star",
      "MUTE": "Mute",
      "MORE": "More",
      "CURRENT_PASSWORD": "Current Password",
      "NEW_PASSWORD": "New Password",
      "CHANGE_PASSWORD": "Change Password",
      "WELCOME_TO_DASHBOARD": "Welcome to Dashboard",
      "GET_MEASURABLE_IMPROVEMENT..": "Get measurable improvement in your working capital efficiency in the order-to-cash & procure-to-pay through our suite of cloud-based solutions.",
      "HERE": "here",
      "USER_PASSWORD_CREATION": "User Password Creation",
      "ENTER_YOUR_PASSWORD_AND_CONFIRM_TO_CONTINUE": "Enter your password and confirm to continue",
      "PASSWORD": "Password",
      "CLICK": "Click",
      "TO_RETURN_TO_LOGIN_PAGE": "to return to Login page",
      "GET_MEASURABLE_IMPROVEMENT_IN_YOUR..": "Get measurable improvement in your working capital efficiency in the order-to-cash & procure-to-pay through our suite of cloud-based solutions.",
      "SIGN_IN": "Sign In",
      "ENTER_YOUR_USERNAME_AND_PASSWORD_TO_ACCESS_DASHBOARD": "Enter your Username and password to access dashboard.",
      "USERNAME": "Username",
      "USERNAME_IS_REQUIRED": "Username is required",
      "BUYER_CODE_IS_REQUIRED": "Buyer code is required",
      "BUYER_NAME": "Buyer Name",
      "BUYER_NAME_IS_REQUIRED": "Buyer name is required",
      "BUYERS_ADDRESS": "Buyer's address",
      "BUYERS_COUNTRY": "Buyer's country",
      "BUYERS_COUNTRY_CODE": "Buyer's country code",
      "BUYERS_STATE": "Buyer's state",
      "BUYERS_STATE_CODE": "Buyer's state code",
      "BUYERS_CITY": "Buyer's city",
      "BUYERS_POSTAL_CODE": "Buyer's postal code",
      "BUYERS_MOBILE_NUMBER": "Buyer's mobile number",
      "BUYERS_MOBILE_NUMBER_IS_REQUIRED": "Buyer's mobile number is required",
      "BUYERS_TELEPHONE_NUMBER": "Buyer's telephone number",
      "BUYERS_EMAIL": "Buyer's email",
      "VALUE_SHOULD_BE_AN_EMAIL": "Value should be an email",
      "CREATE_BUYER": "Create Buyer",
      "FILTER_BY_DATE": "Filter by Date",
      "NO_CREDITS_FOUND_FOR_SELECTED_BUYERS.": "No Credits Found for selected Buyers.",
      "PLEASE_SELECT_BUYERS": "Please Select Buyers.",
      "ELIGIBLE_BUYERS_NOT_FOUND": "Eligible Buyers not found.",
      "AMT_TO_ASSIGN": "Amt to assign",
      "DEDUCTIONS": "Deductions",
      "NO_DOCUMENTS_FOUND_FOR_SELECTED_BUYERS": "No Documents Found for selected Buyers.",
      "BACK_TO_INVOICES": "Back to Invoices",
      "CONFIRM_MANUAL_OFFSET": "Confirm Manual Offset",
      "CONFIRM_PAYMENT_TRANSFER": "Confirm Payment Transfer",
      "CONFIRM_SUSPENSE_CLEARANCE": "Confirm Suspense Clearance",
      "CONFIRM_DEDUCTIONS": "Confirm Deductions",
      "CHANGED": "Changed",
      "REJECTFORSELLER": "Reject",
      "SELECT_OR_DRAG_OUTSTANDING_LEDGER_FILE_TO_UPLOAD": "Select or Drag Outstanding Ledger file to upload.",
      "FILE_TEMPLATE": "File Template",
      "UPLOAD_LEDGER": "Upload Ledger",
      "PLEASE_ENTER_REMARK_TO_CONTINUE": "Please enter remark to continue",
      "NO_CN_FOUND_MATCHING_ENTERED_NO.": "No CN found matching entered no.",
      "NO_CN_FOUND_WITH_DUE_AMOUNT_LESS_THAN_OR_EQUAL_TO": "No CN found with due amount less than or equal to",
      "CN_NO": "CN No",
      "CN_DATE": "CN Date",
      "RECON_REQUEST_CONFIRMATION": "Recon Request Confirmation",
      "PAYMENT_TRANSFER_REQUEST_CONFIRMATION": "Payment Transfer Request Confirmation",
      "SUSPENSE_CLEARANCE_REQUEST_CONFIRMATION": "Suspense Clearance Request Confirmation",
      "RECON_FILE_UPLOADED": "Recon File Uploaded",
      "SUPPORTING_DOCUMENT_UPLOADED": "Supporting Document UPLOADED",
      "VIEW_ZERO_INVOICES": "View Zero Invoices",
      "ZERO_INVOICES_DETAIL": "Zero Invoices Detail",
      "RECON_STATUS": "Recon Status",
      "DOC_ID": "Doc ID",
      "VIEW_INVOICES": "View Invoices",
      "INVOICES_DETAIL": "Invoices Detail",
      "BANK_UTR": "Bank UTR",
      "PAY_MODE": "Pay Mode",
      "VIEW_PAYMENTS": "View Payments",
      "PAYMENTS_DETAIL": "Payments Detail",
      "CHECKER_DATE": "Checker Date",
      "CHECKER": "Checker",
      "MAKER_REQUEST_DATE": "Maker Request Date",
      "MAKER": "Maker",
      "APPROVAL_STATUS": "Approval Status",
      "REQUEST_ID": "Request ID",
      "PAYMENT_TRANSFER_CONFIRMATION": "Payment Transfer Confirmation",
      "PAYMENT_TRANSFER_CONFIRMATION_SUCCESSFULLY": "Payment Transfer Confirmation Successfully",
      "UPDATE_BUYER_DETAILS": "Update Buyer Details",
      "ENTER_NEW_MOBILE_NUMBER": "Enter New Mobile Number",
      "OLD_MOBILE_NUMBER": "Old Mobile Number",
      "APPROVE_MODIFY_REJECT_DEDUCTION": "Approve/Modify/Reject Deduction",
      "DIFFERENCE": "Difference",
      "DEDUCTION_AMOUNT": "Deduction Amount",
      "INVOICE_KNOCK_OFF": "Invoice Knock-Off",
      "SUCCESS_FOR_SELLER": "Success",
      "MESSAGE": "Message",
      "DOCUMENT_TRACK": "Document Track",
      "USER": "User",
      "DATE_AND_TIME": "Date and Time",
      "NO_DATA_FOUND_FORSELLER": "No data found",
      "KNOCK_OFF_SUMMARY": "Knock-off summary",
      "TOTAL_CREDITS_SELECTED": "Total Credits Selected",
      "TOTAL_CREDIT_AMT": "Total Credit Amt",
      "DOCUMENTS_SELECTED_FOR_OFFSET": "Documents Selected For Offset",
      "TOTAL_OFFSET_AMT": "Total Offset Amt",
      "REMARK": "Remark",
      "PASSWORD_FOR_SELLER": "Password",
      "YES_KNOCK_OFF": "Yes, knock-off",
      "ENTER_AMOUNT_IN_USD": "Enter Amount in USD",
      "ENTER_PAYMENT_DATE": "Enter Payment Date",
      "ENTER_PAYMENT_REFERENCE_NO": "Enter Payment Reference No",
      "INVFORSELLER": "Inv",
      "PLEASE_ENTER_AMOUNT_TO_PAY_NOT_EXCEEDING_THE_DUE_AMOUNT_OF": "Please enter amount to pay not exceeding the Due Amount of",
      "APPLY_DEDUCTIONS": "Apply Deductions",
      "SELECT_DEDUCTION_REASON": "Select Deduction Reason",
      "DEDUCTION_REASON": "Deduction Reason",
      "SELECT_REASON_ENTER_VALID_AMOUNT_AND_CLICK_THE_PLUS_SIGN_TO_ADD_DEDUCTION": "Select reason, enter valid amount and click the plus sign to add deduction",
      "SELECT_ACCOUNT_NUMBER": "Select Account Number",
      "PLEASE_SELECT_WHICH_CUSTOMER_ACCOUNT_TO_MAP_IT_TO": "Please select which customer account to map it to.",
      "THE_REMITTER_ACCOUNT_NUMBER": "The remitter account number from which the payment has been received is not tagged to any customer account number",
      "ASSIGN_0_INVOICE_TO_ACCOUNT": "Assign 0 Invoice to Account",
      "SELECT_ACCOUNT_NUMBER_TO_ASSIGN": "Select account number to assign",
      "NOT_AUTHORIZED": "Not Authorized",
      "PLEASE_CLICK_BUTTON_BELOW_TO_NAVIGATE_BACK_TO_HOME_PAGE": "Please click button below to navigate back to home page",
      "BACK_TO_HOME": "Back to Home",
      "LOGGED_OUT": "Logged Out",
      "YOU_HAVE_SUCCESSFULLY_LOGGED_OUT": "You have successfully logged out.",
      "RE_LOGIN": "Re-login",
      "ADD_A_NEW_LANGUAGE": "Add A New Language",
      "AVAILABLE_LANGUAGES": "Available Languages",
      "FLAG": "Flag",
      "NAME": "Name",
      "SHORT_CODE": "Short Code",
      "BASIC_LANGUAGE_INFO": "Basic Language Info",
      "ADD_A_LANGUAGE": "Add A Language",
      "ABBREVIATION": "Abbreviation",
      "UPLOAD_LANGUAGE_FLAG": "Upload Language Flag",
      "UPLOAD_TRANSLATION_JSON_FILE": "Upload Translation JSON File",
      "TRANSLATIONS_MANUAL_ENTRIES": "Translations Manual Entries",
      "TRANSLATIONS": "Translations",
      "PREVIOUS": "Previous",
      "DOWNLOAD_TEMPLATE": "Download Template",
      "LANGUAGE_FILE_JSON": "Language File (JSON)",
      "SAVE_CHANGES": "Save Changes",
      "PENDING_CREDIT_AMOUNT": "Pending Credit Amount",
      "PAYMENT_ADVICE_INVOICE_STATUS": "Payment Advice Invoice Status",
      "BUYERWISE_OUTSTANDING_AR_SNAPSHOT": "Buyerwise Outstanding A/R Snapshot (Top 100)",
      "COLLECTION_LIVE_HEALTH": "Collection Live Health",
      "COUNT_OF_DOCUMENTS..": "Count of Documents",
      "DOCUMENTS_AGE": "Documents age",
      "TOTAL_CUSTOMERS_ACTIVE_ON_FREEPAY": "Total customers active on Freepay",
      "TOTAL_PENDING_DOCUMENTS_ON_FREEPAY": "Total pending Document(s) on Freepay",
      "TOTAL_PAID_DOCUMENT_ON_FREEPAY": "Total paid Document(s) on Freepay",
      "TOTAL_OVERDUE_DOCUMENT_ON_FREEPAY": "Total overdue Document(s) on Freepay",
      "CUSTOMER_SELECTION": "Customer Selection",
      "AGEING_BASIS_DUE_DATE": "Ageing Basis Due Date",
      "NOT_DUE": "Not Due",
      "1_15_DAYS": "1-15 Days",
      "16_30_DAYS": "16-30 Days",
      "31_60_DAYS": "31-60 Days",
      "61_90_DAYS": "61-90 Days",
      "91_180_DAYS": "91-180 Days",
      ">_180_DAYS": "> 180 Days",
      "ENTER_OTP": "Enter OTP",
      "RECONCILED": "Reconciled",
      "OUT_OF": "out of",
      "VIEW_BUYERS": "View Buyers",
      "CONSOLIDATED_BUYER": "Consolidated Buyer",
      "ADVANCE_PAYMENTS_&_RP": "Advance Payments & RP",
      "LANGUAGE_SETTINGS": "Language Settings",
      "PAYMENT_ADVICES": "Payment Advices",
      "APPROVAL_QUEUE_DEDUCTIONS": "Approval Queue Deductions",
      "EXCEPTIONS": "Exceptions",
      "LEDGER_UPLOAD": "Ledger Upload",
      "INVOICE_KNOCKOFF": "Invoice Knockoff",
      "SELLER_MANAGEMENT": "Seller Management",
      "ADMIN_AXIS_SSO_LOGS": "Admin - Axis SSO Logs",
      "MONGO_ADMIN_QUERY": "Mongo Admin - Query",
      "DASHBOARD_UPDATES_STATS": "Dashboard Updates Stats",
      "EDIT_BUYER": "Edit Buyer",
      "APPROVE_BUYER": "Approve Buyer",
      "DATA_LOADING_UTILITY": "Data Loading Utility",
      "MANUAL_RECON": "Manual Recon",
      "DEDUCTION_HISTORY": "Deduction History",
      "TOTAL_DOCUMENT_AMT_SELLER": "Total Documents Amt",
      "DOC_TYPE": "Doc Type",
      "PAYMENT_ADVICE": "Payment Advice",
      "REJECTION_APPROVAL PENDING": "Rejection Approval Pending",
      "MOBILE": "Mobile",
      "BANK_COMMENTS": "Bank Comments",
      "COMMENTS": "Comments",
      "POSTING_DATE": "Posting Date",
      "POSTING_NO": "Posting No.",
      "ROUND-OFF_AMOUNT": "Round-off Amount",
      "APPROVED_TIME": "Approved Time",
      "CASH_DISCOUNT_": "Cash Discount",
      "PRESENTMENT_DATE": "Presentment Date",
      "PAYMENT_MODE": "Payment Mode",
      "E_Mail": "E-Mail",
      "MOBILE_NUMBER_": "Mobile Number",
      "TEL_NUMBER": "Tel. Number",
      "BRANCH": "Branch",
      "CITY": "City",
      "STATE": "State",
      "ACTIVATION": "Activation",
      "TOTAL_NO_OF_INVOICE": "Total no. of Invoice",
      "INVOICE_DUE_AMOUNT": "Invoice Due Amount",
      "NO_OF_DEBIT_NOTES": "No. of Debit notes",
      "TOTAL_DEBIT_AMOUNT": "Total Debit Amount",
      "DEBIT_DUE_AMOUNT": "Debit Due Amount",
      "NO_OF_CREDIT_NOTES": "No. of Credit Notes",
      "TOTAL_CREDIT_AMOUNT": "Total Credit Amount",
      "CREDIT_DUE_AMOUNT": "Credit Due Amount",
      "NET_OUTSTANDING": "Net Outstanding",
      "TRANSACTION_ID": "Transaction Id",
      "CREDIT_NOTE_NUMBER": "Credit-Note Number",
      "CREDIT_NOTE_DATE_": "Credit-Note Date",
      "ORIGINAL_AMOUNT": "Original Amount",
      "AMOUNT_USED": "Amount Used",
      "AMOUNT_PENDING": "Amount Pending",
      "REF_NUMBER": "Ref Number",
      "OUTSTANDING_AMOUNT": "Outstanding Amount",
      "PAYMENT_ADVICE_AMOUNT": "Payment Advice Amount",
      "PAYMENT_RECV_DATE": "Payment Recv Date",
      "AGEING_STATUS": "Ageing Status",
      "NARRATION": "Narration",
      "ADJUSTMENTS": "Adjustments",
      "PAYMENT_ADVICES_LINKED": "Payment Advices Linked",
      "INVOICE_LINKED": "Invoice Linked",
      "PAYMENT_VALUE_DATE": "Payment Value Date",
      "PAYMENT_AMOUNT_RECEIVED": "Payment Amount Received",
      "ACTION_BY": "Action By",
      "ACTION_DATE": "Action Date",
      "SUBMITTED_BY": "Submitted By",
      "SUBMITTED_DATE": "Submitted Date",
      "AGEING": "Ageing",
      "TIMESTAMP": "Timestamp",
      "PROCESS": "Process",
      "DOCUMENT_NO": "Document No.",
      "DOCUMENT_TYPE": "Document Type",
      "EXCEPTION_TYPE": "Exception Type",
      "FILE_NAME": "File Name",
      "REQUEST": "Request",
      "RESPONSE": "Response",
      "OTHER_DATA": "Other Data",
      "REQUESTED_DATE": "Requested Date",
      "CHECKED_BY": "Checked By",
      "CHECKED_DATE": "Checked Date",
      "APPROVED_BY": "Approved By",
      "DESTINATION_AMOUNT": "Destination Amount",
      "DESTINATION_INVOICE_NUMBERS": "Destination Invoice Number(s)",
      "DESTINATION_BUYER_CODES": "Destination Buyer Code(s)",
      "SOURCE_AMOUNT": "Source Amount",
      "SOURCE_INVOICE_NUMBER": "Source Invoice Number",
      "SOURCE_BUYER_CODE": "Source Buyer Code",
      "PAYMENT_ADVICE_NUMBER": "Payment Advice Number",
      "DOCUMENT_AMOUNT": "Document Amount",
      "PAYMENT_STATUS": "Payment Status",
      "FINAL_APPROVAL_BY": "Final Approval By",
      "APPROVAL_DATE": "Approval Date",
      "FINAL_APPROVAL_DATE": "Final Approval Date",
      "DUE_POST_ASSIGNEMENT": "Due Post Assignement",
      "VIEW_DEDUCTIONS": "View Deductions",
      "UPDATE_BUYERS_LIST": "Update Buyers List",
      "APPROVAL_QUEUE_FOR_DEDUCTIONS": "Approval Queue for Deductions",
      "APPROVAL_QUEUE_FOR_PAYMENTS": "Approval Queue for Payments",
      "APPROVAL_QUEUE_FOR_SUSPENSE_CLEARANCE": "Approval Queue for Suspense Clearance",
      "APPROVAL_QUEUE_FOR_PAYMENT_TRANSFERS": "Approval Queue for Payment Transfers",
      "SUSPENSE_CLEARANCE": "Suspense Clearance",
      "MANUAL_OFFSETS": "Manual Offsets",
      "OPEN_INVOICES": "Open Invoices",
      "SELLER_DATA": "Seller Data",
      "VIEW_INT-FT": "View INT-FT",
      "MONGO_QUERY": "Mongo Query",
      "VIEW_AXIS_SSO_LOGS": "View Axis SSO Logs",
      "EDIT_SELLER": "Edit Seller",
      "NEW_SELLER": "New Seller",
      "VIEW_SELLER": "View Seller",
      "SELLER_CONFIGURATION": "Seller Configuration",
      "MANAGE_SELLERS": "Manage Sellers",
      "VIEW_LEDGER": "View Ledger",
      "VIEW_PAYMENT_ADVICES": "View Payment Advices",
      "VIEW_CREDIT_NOTES_": "View Credit Notes",
      "INVOICES_": "Invoices",
      "LEDGER": "Ledger",
      "SELECT_A_SELLER": "Select a seller",
      "MANAGE_INCOMING_PAYMENT_MODES": "Manage Incoming Payment Modes",
      "SELECT_INCOMING_PAYMENT_MODES": "Select Incoming Payment Mode",
      "SELECT_PAYMENT_MODE": "Select Payment Mode",
      "SELECT_CARD_TYPE": "Select Card Type",
      "PLEASE_SELECT_A_BUYER_S": "Please select Buyer(s)",
      "BUYER_ORG": "Buyer Org",
      "PLEASE_ENTER_MERCHANT_ID": "Please enter Merchant ID",
      "PLEASE_ENTER_GUID": "Please enter GUID",
      "PLEASE_ENTER_SHARED_KEY": "Please enter Shared Key",
      "PLEASE_ENTER_WSAUSER_ACCOUNT_CREDENTIALS": "Please enter WSAUser Account Credentials",
      "PLEASE_ENTER_PASSWORD": "Please enter Password",
      "ORG": "Org",
      "ADD_MERCHANT_ID": "Add Merchant ID",
      "SUCCESs": "Success",
      "MERCHANT_ID_ADDED_SUCCESSFULLY": "Merchant ID Added Successfully",
      "ADD": "add",
      "ADD_NEW": "Add New",
      "CLICK_TO_EXPAND": "Click To Expand",
      "EMAIL": "Email",
      "COLLAPSE": "Collapse",
      "EIPP_SUB_PARAMETERS": "EIPP Sub-Parameters",
      "UPDATE_APP_CONFIG": "Update App Config",
      "DOWNLOAD_PAYMENT_STATEMENT": "Download Payment Statement",
      "FROM_TIME": "From Time",
      "TO_TIME": "To Time",
      "VIEW_MERCHANT_IDS": "View Merchant IDs",
      "CREATE_MERCHANT_ID": "Create Merchant ID",
      "CURRENCY_CODE": "Currency Code",
      "ENTER_CURRENCY_CODE": "Enter currency code",
      "RE_UPLOAD_SELLER_JSON": "Re-upload Seller JSON",
      "EDIT_USER": "Edit User",
      "VIEW_JSON": "View JSON",
      "YES": "Yes",
      "UPDATE_SELLER": "Update Seller",
      "SAVE_SELLER": "Save Seller",
      "UPDATE_JSON": "update JSON",
      "USER_NAME": "User name",
      "UPDATE_USER": "Update User",
      "UPDATEJSON": "updateJson",
      "UPDATE_SELLER_BY_JSON": "Update Seller by JSON",
      "UPDATEUSER": "updateUser",
      "SELLERMANAGEMENT": "sellermanagement",
      "SORT_BY": "Sort By",
      "ADD_NEW_SELLER": "Add New Seller",
      "ADD_NEW_SELLER_USING_JSON": "Add New Seller Using JSON",
      "MANAGE": "Manage",
      "DB": "DB",
      "SELLER__DATA": "seller-data",
      "SELECT_OR_DRAG_ACK_FILE_TO_UPLOAD": "Select or Drag ACK file to upload.",
      "UPLOAD_ACK_FILE": "Upload Ack File",
      "DEACTIVATED": "Deactivated",
      "DELETE_SELLER": "Delete Seller",
      "SELLERMANAGEMENTVIEW": "sellermanagementview",
      "SELLERMANAGEMENTNEW": "sellermanagementnew",
      "SELLER__CONFIGURATION": "seller-configuration",
      "SELLER_DETAILS": "Seller Details",
      "USER_DETAILS": "User Details",
      "SELLER_JSON": "Seller JSON",
      "DBADMINDASHBOARDUPDATESSTATS": "dbAdminDashboardUpdatesStats",
      "COLLECTION_NAME": "Collection Name",
      "LAST_UPDATE_TIME": "Last update time",
      "RESET_TO_ENTERED_TIME": "Reset to entered time",
      "RESET_TIME": "Reset Time",
      "CACHED_STATS_COLLECTIONS": "Cached Stats Collections",
      "DATA_LOAD_UTILITY": "Data load utility",
      "LEDGER_UNPAID_DOCUMENTS": "Ledger - unpaid document(s)",
      "DOCUMENT_TYPES": "Document Type(s)",
      "SELECT_DOCUMENT_TYPES": "Select document type(s)",
      "DOC_AMOUNT_RANGE": "Doc amount range",
      "DOC_DATE_RANGE": "Doc date range",
      "DUE_DATE_RANGE": "Due date range",
      "DOCUMENT_AMOUNT_RANGE": "Document amount range",
      "DOCUMENT_DATE_RANGE": "Document date range",
      "0_60_INDICATES_DOCS_WILL_BE_ADDED_WITH_RANDOM_DOC_DATE_OF_CURRENT_DATE": "Eg. 0-60 indicates docs will be added with random doc date of, current date - (Random number between 0 to 60), set this value to 0 to make doc date same as current date for all docs.",
      "0_60_INDICATES_DUE_DATE_WILL_BE_ADDED_WITH_DOCDATE": "Eg. 0-60 indicates due date will be added with, docDate + (Random no. between 0 to 60), set this value to 0 to always make dueDate same as docDate",
      "BUYER_LOGINS": "Buyer login(s)",
      "ENTER_COMMA_SEPARATED_BUYER_LOGINS": "Enter comma separated buyer logins",
      "ENTER_COMMA_SEPARATED_BUYER_LOGINS_FOR_BUYERS_FOR_WHOME_WISH_TO_UPLOAD_DATA": "Enter comma separated buyer logins (phones / emails) for buyers for whom you wish to upload data, leave blank if you want to pick any buyer from mapped buyers.",
      "TEMPLATE_DOCUMENT_IDS": "Template document id(s)",
      "ENTER_COMMA_SEPERATED_DOCUMENT_IDS": "Enter comma separated document ids",
      "ENTER_ID_OF_THE_DOCUMENTS_TO_BE_USED_AS_TEMPLATES_USEFUL_WHEN_YOU_HAVE_CUSTOM_FIELDS_IN_LEDGER": "Enter id of the document(s) to be used as templates, useful when you have custom fields in ledger those needed to be copied over. (Not Working)",
      "NO_OF_DOCS_TO_UPLOAD": "No of docs to upload",
      "ENTER_COUNT_FOR_THE_NO_OF_DOCS_TO_UPLOAD": "Enter count for the no of docs to upload",
      "ADD_DOCUMENTS": "Add document(s)",
      "COLLECTIONS": "Collections",
      "FILTER_COLLECTIONS": "Filter Collections",
      "MONGO_QUERY_EXECUTION": "mongo-query-execution",
      "CLICK_TO_COPY_TO_CLIPBOARD": "Click to copy to clipboard",
      "ADVANCE_PAYMENT_AND_RP": "Advance Payments & RP",
      "SHOW_RECORD_PAGESIZE": "Show {{pageSize}} Records",
      "EXPORT_1000_RECORDS_TO_CSV": "Export 10000 records to csv",
      "EXPORT_TO_CSV": "Export to csv",
      "TOTAL_DOC_S_SELECTED": "Total Doc(s) Selected",
      "TOTAL_DUE_AMOUNT": "Total Due Amount",
      "GENERATE_PAYMENT_LINK": "Generate Payment Link",
      "DEDUCTIONS_EVIDENCE": "Deductions Evidence",
      "POSTED": "Posted",
      "PERFECT_MATCH": "Perfect Match",
      "PERFECT_MATCH_WITH_REDUNDANCY": "Perfect Match with Redundancy",
      "PARTIAL_MATCH": "Partial Match",
      "NOT_FOUND": "Not Found",
      "PARTIALLY_USED": "Partially Used",
      "BANK_PROCESS": "Bank Process",
      "SELECT_DOCUMENT_DATE_RANGE": "Select Document date range",
      "SELECT_DOCUMENT_DUE_DATE_RANGE": "Select Document due date range",
      "SELECT_PAY_DATE_RANGE": "Select Pay date range",
      "SEARCH_FILTER_TEXT": "Search {{text}}",
      "SEARCH_BY_CHANGING_SLIDER": "Search by changing slider",
      "SEARCH_BANK_UTR": "Search Bank UTR",
      "DUE_DAYS": "Due Days",
      "PAID_DAYS": "Paid Days",
      "SELECT_INVOICE_DATE_RANGE": "Select Invoice date range",
      "SELECT_INVOICE_DUE_DATE_RANGE": "Select Invoice due date range",
      "INVOICE_NO": "Invoice no.",
      "SUBMITTED_NAME": "Submitted Name",
      "SELECT_SUBMITTED_DATE_RANGE": "Select Submitted Date Range",
      "SELECT_CREDIT_NOTE_DATE_RANGE": "Select Credit Note Date range",
      "CREDIT_NOTE_NO": "Credit-note no.",
      "SELECT_TYPE": "Select Type",
      "RP": "RP",
      "REF_NO": "Ref no.",
      "BUYER_STATUS": "Buyer Status",
      "SELECT_CREATION_DATE_RANGE": "Select Creation Date range",
      "SELECT_RECONSTATUS": "Select Reconstatus",
      "SEARCH_WITH_REQUEST": "Search within Request",
      "SEARCH_WITHIN_RESPONSE": "Search within Response",
      "WILDCARD_SEARCH": "Wildcard Search",
      "SELECT_ACCOUNT": "Select Account",
      "ACCOUNT_SELECTED": "Amount selected",
      "INVOICE_SELECTED_AMOUNT": "Invoice Selected Amount",
      "TOTAL_DEDUCTIONS": "Total Deductions",
      "THE_BALANCE_DUE_POST_ASSIGNMENT_CANNOT_BE_NEGATIVE_PLEASE_ADJUST_THE_ALLOCATION_OF_THE_INVOICES_TO_PROCEED": "The Balance/Due Post Assignment cannot be negative. Please adjust the allocation of the invoice(s) to proceed",
      "ASSIGN_FULL_AMOUNT_TO_0_INVOICE": "Assign Full Amount To 0 Invoice",
      "SELECT_AND_MATCH": "Select and match",
      "BACK_TO_CREDIT_NOTES": "Back to Credit Notes",
      "BACK_TO_DEDUCTIONS": "Back to Deductions",
      "BACK_TO_PAYMENTS": "Back to Payments",
      "aCTIVATE": "activate",
      "dEACTIVATE": "deactivate",
      "AWAITING_BANK_MIS": "Awaiting Bank MIS",
      "AXIS_SSO_LOGS": "Axis SSO Logs",
      "SEARCH_BY_NAME": "Search By Name",
      "ORG_CODE": "Org Code",
      "ORG_NAME": "Org Name",
      "PARENT_ORG": "Parent Org",
      "ADD_NEW_ORG": "Add New Org",
      "PAYMENT_INSTRUMENT": "Payment Instrument",
      "CARD": "Card",
      "VIEW_LIST": "View List",
      "DOWNLOAD_MAPPING": "Download Mapping",
      "VIEW_BUYER_CODES": "View Buyer Codes",
      "BUYER_CODES": "Buyer Codes",
      "PAYMENT": "Payment",
      "INVOICE_DEBIT_NOTE_CREDIT_NOTE": "Invoice/ Debit Note/ Credit Note",
      "FILE_PROCESS": "File Process",
      "NOTIFICATIONS": "Notifications",
      "ESCALATION": "Escalation",
      "SELLERDASHBOARD": "sellerDashboard",
      "PAYMENT_METHODS": "Payment Methods",
      "PAYMENT_PROCESS": "Payment Process",
      "PART_PAYMENT": "Part Payment",
      "INVOICE_INV": "Invoice (INV)",
      "CREDIT_NOTE_CN": "Credit Note (CN)",
      "DEBIT_NOTE_DN": "Debit Note (DN)",
      "TEST": "test",
      "SELECT_AN_ORG_PARENT": "Select an Org parent",
      "SEARCH_BY_BUYER_CODE_NAME": "Search by buyer code/name",
      "SEARCH_BY_BUYER_CODE_OR_BUYER_NAME": "Search by buyer code or buyer name....",
      "EXAMPLE_OF_QUERY_TRANSWORLDLEDGER_FIND_ID": "Example of Query transworldLedger.find({_id:'123'})",
      "ADVANCE_PAYMENTS": "Advance Payments",
      "INVOICES_AND_DEBIT_NOTES": "Invoices & Debit Notes",
      "HIDE": "Hide",
      "SHOW": "Show",
      "OUTSTANDING_AR_SNAPSHOT_TOP_100": "Outstanding A/R Snapshot (Top 100)",
      "ALL": "All",
      "TOTAL_BUYERS_ACTIVE": "Total buyers active",
      "AGEING_REPORT": "Ageing Report",
      "RV_WITH_CREDIT": "RV With Credit",
      "RV_WITHOUT_CREDIT": "RV Without Credit",
      "UNALLOCATED_PAYMENTS": "Unallocated Payments",
      "KC_DEDUCTIONS": "KC Deductions",
      "QUANTITY_VARIANCE": "Quantity Variance",
      "PRICE_VARIANCE": "Price Variance",
      "RETURN_TO_VENDOR": "Return to Vendor",
      "OTHERS": "Others",
      "UNALLOCATED_CLAIMS": "Unallocated Claims",
      "TOTAL_RECEIVABLES": "Total Receivables",
      "SEARCH_CN_NO": "Search CN No",
      "ENTER_REMARK": "Enter remark",
      "SUSPENSE_CLEARANCE_CONFIRMATION": "Suspense Clearance Confirmation",
      "RECON_CONFIRMATION": "Recon Confirmation",
      "ENTER_APPROVED_AMOUNT": "Enter Approved Amount",
      "APPROVING": "approving",
      "REJECTING": "rejecting",
      "NO_I_WANT_TO_EDIT": "No, I want to edit",
      "ENTER_PASSWORD": "Enter password",
      "ENTER_PAYMENT_DETAILS": "Enter Payment Details",
      "APPLY_PARTIAL_PAYMENT": "Apply Partial Payment",
      "SELECT_DEDUCTIONS": "Select Deductions",
      "ASSIGN_REMITTER_ACCOUNT_NUMBER": "Assign Remitter Account Number",
      "ADD_MULTIPLE_BUYER_CODES_SEPARATED_BY_COMMAS_NO_SPACES": "Add multiple buyer codes separated by commas **no spaces",
      "ENTER_BUYER_NAME": "Enter buyer name",
      "ENTER_BUYERS_ADDRESS": "Enter buyer's address",
      "ENTER_BUYERS_EMAIL": "Enter buyer's email",
      "ENTER_BUYERS_COUNTRY": "Enter buyer's country",
      "ENTER_BUYERS_COUNTRY_CODE": "Enter buyer's country code",
      "ENTER_BUYERS_STATE": "Enter buyer's state",
      "ENTER_BUYERS_STATE_CODE": "Enter buyer's state code",
      "ENTER_BUYERS_CITY": "Enter buyer's city",
      "ENTER_BUYERS_POSTAL_CODE": "Enter buyer's postal code",
      "ENTER_BUYERS_MOBILE_NUMBER": "Enter buyer's mobile number",
      "ENTER_BUYERS_TELEPHONE_NUMBER": "Enter buyer's telephone number",
      "INVOICES_KNOCKOFF": "Invoice(s) Knockoff",
      "TOTAL_CREDITS": "Total Credits",
      "CREDIT_AMOUNT_SELECTED": "Credit Amount Selected",
      "DUES_AMOUNT_SELECTED": "Dues Amount Selected",
      "SEARCH_BY_CODE_AND_NAME": "Search By Code and Name",
      "SELECT_DOCUMENTS_TO_KNOCKOFF": "Select Documents To Knockoff",
      "MANUAL_OFFSET_SUCCESSFUL": "Manual Offset Successful",
      "PAYMENT_TRANSFER_SUCCESSFUL": "Payment Transfers Successful",
      "SUSPENSE_CLEARANCE_SUCCESSFUL": "Suspense Clearance Successful",
      "WELCOME_TO_FIS_EIPP_SELLER": "Welcome to FIS EIPP 360 - Seller Dashboard",
      "SELLER_ORGANIZATIONS": "Seller Organizations",
      "SELLER_CONFIGURATIONS": "Seller Configurations",
      "MANAGE_BUYERS": "Manage Buyers",
      "PAYMENT_REFERENCE_NUMBER": "Payment Reference Number",
      "SELLER_NAME": "Seller Name",
      "CN_NO_": "CN No.",
      "EXTERNALLY_SETTLED": "Externally Settled",
      "DROP_FILE_HERE_OR_CLICK_TO_UPLOAD": "Drop File here or click to upload",
      "SEARCH_BY_TEXT": "Search by {{text}}",
      "SELECT_CURRENCY_CODE": "Select Currency Code",
      "BUYERS_CODE": "Buyer(s) Code",
      "BUYERS_NAME": "Buyer(s) Name",
      "CREDIT_NOTE_NO_": "Credit Note No.",
      "SAMPLE_NOTIFICATION": "Sample Notification {{position}}",
      "1_MIN_AGO": "1 min ago",
      "5_MIN_AGO": "5 min ago",
      "COOL": "Cool.",
      "2_DAYS_AGO": "2 days ago",
      "SELLER_ORG_CREATION": "Seller Org Creation",
      "ORG_TYPE": "Org Type",
      "NUMBER_OF_BUYERS": "Number Of Buyers",
      "SELLER_ORGS": "Seller Orgs",
      "MANAGE_MERCHANT_IDS": "Manage Merchant IDs",
      "APP_CONFIG": "App Config",
      "SSO_LOGS": "SSO Logs",
      "ES_ADMIN": "ES Admin",
      "MONGO_ADMIN": "Mongo Admin",
      "QUERY": "Query",
      "INT_FT": "INT-FT",
      "SELLER_DASHBOARD": "Seller Dashboard",
      "BUYER_CONTACT_INFO": "Buyer Contact Info",
      "PAYMENT_TAGS": "Payment Tags",
      "SESSIONTIMEOUT": "SESSIONTIMEOUT",
      "UPDATE_-_BUYER": "update-buyer",
      "INPUT_JSON": "Input JSON",
      "UPDATE_BUYER": "Update Buyer",
      "FORM": "Form",
      "JSON": "JSON",
      "CREATE_-_BUYER": "create-buyer",
      "INVOICE_-_KNOCKOFF": "invoice-knockoff",
      "LEDGER_-_UPLOAD": "ledger-upload",
      "RESEND_OTP": "RESEND OTP",
      "RESEND_OTP_TIMER": "RESEND OTP in {{noOfSeconds}} seconds",
      "ADD_NEW_PAY_OPTION": "Add new pay option",
      "DIALOG_HEADER_INGRAM": "Ingram",
      "DIALOG_HEADER_WELLSFARGO": "Wells Fargo",
      "CUSTOMER_REGISTRATION": "Customer Registration",
      "ENTER_REGISTER_CUSTOMER_CODE": "Enter Registered Customer Code",
      "PLEASE_ENTER_VALID_CUSTOMER_CODE": "Please enter valid customer code",
      "ENTER_REGISTER_MOBILE_NO": "Enter Registered Mobile No.",
      "PLEASE_ENTER_VALID_MOBILE_NO": "Please enter valid mobile no.",
      "SELECT_DIVISION_CODE": "Select Division Code",
      "REFRESH_DIVISION_AND_ACCOUNT": "Refresh Division And Account",
      "CHANGE_MOBILE_EMAIL": "Change Mobile / Email"
    },
    "ERRORS": {
      "INCORRECT_PIN": "Incorrect transaction PIN",
      "ERROR": "Error"
    },
    "MESSAGES": {
      "PLEASE_WAIT": "Please wait...",
      "VALID_MOBILE_NUMBER_AND_EMAIL": "Please enter a valid mobile number or email to login",
      "INVOICE_OVERDUE_WARN_PAY_SCREEN": "Please note that you may not be eligible for Cash Discounts if you have Overdue Invoices.",
      "INVOICE_PAY_DISCOUNT_WARN": "*Availability of cash discount is subject to cash discount date slab or clearance of all overdue invoices",
      "CREDITNOTE_SELECTION_CN_NOT_EXACT_OFFSET_CNSPLIT": "The Credit Note amount should be equal to or greater than the Invoice amount.",
      "CREDITNOTE_SELECTION_CN_NOT_EXACT_OFFSET": "The Credit Note amount should be equal to the Invoice amount.",
      "CREDITNOTE_SELECTION_CNSPLIT_INVALID_SELECTION": "You have selected excess credit note(s).",
      "INCORRECT_TRANSACTION_PIN_MAX_ATTEMPTS": "You have exceeded the attempts to enter Transaction PIN to pay. Please try again later.",
      "BANNER_REPSPONSE_YES": "Thank you for your interest. Our team will be shortly in touch with you.",
      "BANNER_REPSPONSE_NO": "We thank you for your response.",
      "DOC_NOT_FOUND": "Document not found, please contact distributor",
      "PAYMENT_ERROR": "Something went wrong with payment, if you have completed the payment, data will be updated in some time.",
      "PAY_URL_ERROR": "Oops, the invoice you are trying to pay is not payable anymore. Please contact your distributor.",
      "INVALID_SERVICE_RESPONSE": "We are unable to process your request at the moment, please try again later.",
      "SERVER_GENERAL_ERROR": "Oops! There seems to be server issue, please give us some time to discipline the server.",
      "SESSION_TIMEOUT": "Your session has timed-out because of inactivity, Please login again to continue.",
      "PAYMENT_METHOD_NOT_ALLOWED": "Selected payment option is not available for this invoice(s). Please select a different payment option",
      "NO_PENDING_CREDIT_NOTES": "No more active credit notes available for you.",
      "NO_USED_CREDIT_NOTES": "It seems you have not used any Credit note.",
      "PIN_RESET_FROM_LOGIN": "Your PIN is successfully updated, please login with new PIN.",
      "SET_UP_SSL": "Congratulations, you have set up SSL Pinning.",
      "DESELECT_CREDIT_NOTES_WITH_AMOUNT": "Please deselect credit note(s) with amt",
      "INCORRECT_PAY_AMOUNT": "Incorrect pay amount entered",
      "ENTER_VALID_AMOUNT": "please enter valid amount",
      "AMOUNT_CANNOT_EXCEED": "amount cannot exceed",
      "NOT_MORE_THAN_BILL_AMOUNT": "Entered amount should not be more than bill amount",
      "WITH_MAX_AVAILABLE_DISCOUNT": "with max available discount.",
      "ENTER_VALID_PAYABLE_AMOUNT": "Please enter valid Payable Amount",
      "CANNOT_SELECT_FUTURE_DATE_OF_PAYMENT": "You cannot select a future date of payment as your selection contains an overdue document",
      "PARTIAL_PAY_ALLOWED_FOR_OVERDUE": "Partial pay is allowed for overdue",
      "UPLOAD_SUCCESSFUL": "Upload Successful",
      "DEDUCTION_AMOUNT_INVALID": "Deduction amount is invalid. Please enter an amount less than or equal to the net amount due.",
      "PLEASE_CONFIRM": "Please Confirm",
      "ENTER_TRANSACTION_PIN": "Please enter transaction PIN to proceed.",
      "INVOICES_MANUAL_KNOCKOFF": "Invoices Manual Knock-off",
      "SELECTION_DATA": "Selection Data",
      "INVOICE_PAYMENT_KNOCKOFF": "Select Invoices to knock-off against payment",
      "SELECTION_RECOMMENDED": "Selection of any of the following invoice(s) is recommended.",
      "CONFIRM_PAYMENT_OF": "Confirm payment of",
      "SELECT_CN_TO_PAY": "Please select CN to Pay",
      "NAVIGATE_TO_REJECT": "Go to \"Dispute/Reject\" window",
      "NAVIGATE_TO_PAYMENTS": "Navigate To \"Payments\"",
      "CHANGING_PAYMENT_METHOD": "Changing the Payment Method will deselect the Credit Note(s).",
      "CHANGING_PAY_DATE": "Changing the Pay Date will deselect the credit notes.",
      "CREDIT_NOTES_DESELECTED": "Credit note(s) will be deselected if you want to pay invoice partially.",
      "CREDIT_NOTES_DESELECTED_AFTER_PARTIAL_PAY": "Previously selected credit note(s) will be deselected if you submit a partial payment. Do you want to proceed?",
      "REJECT_INVOICES": "Reject Invoices",
      "CONFIRM_TO_ASSIGN_CN_TO_SD": "Please confirm to assign selected CN(s) to Security Deposit.",
      "ENTER_VALUE_FOR_COURIER_CHARGES": "Please enter value for courier charges",
      "TDS_LESS_THAN": "TDS can be less than or equal to 10% of invoice amount.",
      "TOTAL_OF_DEDUCTIONS": "Total of deductions",
      "AND_PAYING_AMOUNT": "and paying amount",
      "SHOULD_BE_EQUAL_TO_INV_AMT": "should be equal to Invoice Amount",
      "AMOUNT_EXCEEDS_INVOICE_BY": "Amount paying exceeds invoice amount by",
      "DIFFERENCE_OF_AMOUNT": "There is difference of amount",
      "AMOUNT_PAYABLE_EXCEEDED": "Payable amount entered ({{amount}}) is more than the mandate limit set   ({{payableAmount}}). Please re-enter a lesser value.",
      "FUTURE_DATE_SELECTION": "Future date selection is not allowed for CN Payments, payment date has been reset.",
      "FUTURE_DATE_NOT_ALLOWED": "Future date cannot be selected",
      "MANAGE_PAYMENT_METHOD": "Manage Payment Method",
      "CONFIRM_LOGOUT_QUESTION": "Are you sure you want to logout?",
      "YOUR_PAYMENT_HAS_BEEN_INITIATED_SUCCESSFULLY": "Your payment has been initiated successfully.",
      "BUYER_INVALID_CRED": "You have entered an incorrect PIN. Please re-enter to proceed.",
      "SAME_PIN_ERROR": "You cannot reuse a previous PIN. Please enter a new PIN to proceed.",
      "PASSWORD_UPDATED_SUCCESSFULLY": "PIN Updated Successfully",
      "RTP_LINK_FAILURE_MSG": "The requested link has expired.",
      "UPDATE_FAILED_EXPIRED_OR_INACTIVE_PAYMENT_METHOD": "update failed because payment method is inactive or has expired",
      "EXPIRED_SCHEDULE_PAYMENT_METHOD_MESSAGE": "This payment schedule cannot be activated because the payment method is either expired or inactive.",
      "PAYABLE_AMOUNT_GREATER": "Payable amount entered (payableFormatted) is more than the mandate limit set  ({{formattedAmount}}). Please re-enter a lesser value.",
      "PLEASE_SELECT_PAYMENT_METHOD": "Please Select Payment Method",
      "VALID_MOBILE_OR_EMAIL": "Please enter a valid mobile number or email",
      "NO_DATA_FOUND_FOR_THE_SELECTED_PAYMENT_METHOD": "No data found for the selected payment method.",
      "INVALID_USERNAMEORPASSWORD_ERROR": "Please enter a correct username or password",
      "IF_CARD_EXPIRED_PAYMENT_METHOD": "You cannot change your pay date because your card expires today. To change the date, please select a different payment method.",
      "PLEASE_WAIT_INITIALIZE_PAYMENT": "Please wait, initializing payment...",
      "INVALID OTP": "Invalid OTP",
      "STATS_FAILED": "Your Session is invalid/expired! Please log in again!",
      "NO_SELLER_MAPPING": "User is not mapped with any seller",
      "PLEASE_CHANGE_YOUR_PASSWORD_TO_CONTINUE.": "Please change your password to continue.",
      "CURRENT_PASSWORD_IS_REQUIRED": "Current Password is required",
      "NEW_PASSWORD_IS_REQUIRED": "New Password is required",
      "PASSWORD_MUST_BE_AT_LEAST_6_CHARACTERS": "Password must be at least 6 characters",
      "CONFIRM_PASSWORD": "Confirm Password",
      "CONFIRM_PASSWORD_IS_REQUIRED": "Confirm Password is required",
      "PASSWORDS_MUST_MATCH": "Passwords must match",
      "PASSWORD_CREATED_SUCCESSFULLY": "Password Created Successfully",
      "PLEASE_CLICK": "Please click",
      "PASSWORD_IS_REQUIRED": "Password is required",
      "PASSWORD_CONFIRMATION_IS_REQUIRED": "Password Confirmation is required",
      "PASSWORD_CREATION_ERROR": "Password Creation Error",
      "THE_PASSWORD_CREATION_LINK_IS_INVALID": "The password creation link is invalid",
      "THE_PASSWORD_CREATION_LINK_HAS_EXPIRED": "The password creation link has expired",
      "CARD_TYPE_IS_REQUIRED": "Card Type Is Required",
      "ORG_IS_REQUIRED": "Org is required",
      "PLEASE_SELECT_ORGS_IN_THE_PREVIOUS_TAB": "Please select org(s) in the previous tab",
      "CURRENCY_IS_REQUIRED": "Currency is required",
      "MERCHANT_ID_IS_REQUIRED": "Merchant ID Is Required",
      "GUID_IS_REQUIRED": "GUID Is Required",
      "SHARED_KEY_IS_REQUIRED": "Shared Key Is Required",
      "WSA_USER_ACCOUNT_IS_REQUIRED": "WSA User Account Is Required",
      "TRANSACTION_NOT_FOUND": "Transaction not found.",
      "YOU_HAVE_NO_INCOMING_PAYMENT_MODES_TO_MANAGE_PLEASE_CLICK_ON_TO_MANAGE_THE_SAME": "You have no incoming payment modes to manage. Please click on 'Add incoming payment mode' to manage the same.",
      "ARE_YOU_SURE_YOU_WANT_TO_SAVE_THIS_CHANGES": "Are you sure you want to save this changes?",
      "EMAIL_IS_INVALID": "Email is invalid",
      "ARE_YOU_SURE_YOU_WANT_TO_SAVE_THESE_CHANGES": "Are you sure you want to save these changes?",
      "ARE_YOU_SURE_YOU_WANT_TO_PERMANENTLY_DELETE_THIS_SELLER": "Are you sure you want to permanently delete this Seller?",
      "NO_SELLERS_FOUND_FOR_SELECTED_CRITERIA_PLEASE_REFINE_YOUR_SEARCH": "No sellers found for selected criteria, please refine your search.",
      "CONFIGURED_SELLERS_NOT_FOUND_PLEASE_CONTACT_SYSTEM_ADMINISTRATOR": "Configured sellers not found, please contact system administrator.",
      "ARE_YOU_SURE_YOU_WANT_TO_DEACTIVATE_THIS_SELLER": "Are you sure you want to deactivate this Seller?",
      "ARE_YOU_SURE_YOU_WANT_TO_ACTIVATE_THIS_SELLER": "Are you sure you want to activate this Seller?",
      "ARE_YOU_SURE_YOU_WANT_TO_SAVE_THE_JSON_FILE": "Are you sure you want to save the JSON file?",
      "PLEASE_ENTER_A_VALID_VALUE_FOR_KEY": "Please enter a valid value for {{key}}",
      "PLEASE_ENTER_A_VALID_VALUE_FOR_EMAIL": "Please enter a valid value for Email",
      "ARE_YOU_SURE_YOU_WANT_TO_SAVE_THIS_SELLER": "Are you sure you want to save this seller.",
      "PR0CEED_WITH_DUMMY_DATA_UPLOAD_FOR_ID": "Proceed with dummy data upload for {{id}}",
      "DOCUMENTS_ADDED_TO_LEDGER": "{{noOfDocsAdded}} Document(s) added to ledger",
      "NO_DOCUMENTS_FOUND_FOR_SELECTED_CRITERIA": "No documents found for selected criteria.",
      "PAYMENT_MODE_IS_REQUIRED": "Payment Mode Is Required",
      "GENERATE_PAYMENT_LINK_FOR_SELECTED_DOCUMENTS": "Generate payment link for selected document(s)",
      "PLEASE_NOTE_RTP_LINK_IS_ALREADY_GENERATED_FOR_DOCUMENTS_DOCS": "Please note RTP link is already generated for document(s) {{docs}}",
      "UNEXPECTED_ERROR": "Unexpected Error",
      "RTP_REQUESTED_DOC_ALREADY_GENERATED": "Requested document(s) not found or a payment request has been generated for one of the selected documents.",
      "RTP_EMAIL_INITIATED_MSG": "A payment request has been initiated to the buyer, {{buyerName}}.",
      "THE_REMAINING_BALANCE_OF_BALANCE_WOULD_ASSIGNED_TO_ACCOUNT_NUMBER": "The remaining balance of {{balance}} would assigned to account number {{accountNumber}}?",
      "YOU_HAVE_REMAINING_BALANCE_OF_BALANCE_WOULD_YOU_ASSIGN_TO_0_INVOICE": "You have remaining balance of {{balance}}. Would you want to assign to 0 invoice?",
      "YOUR_SESSION_HAS_TIMED_OUT_PLEASE_LOGIN_AGAIN_TO_CONTINUE": "Your session has timed-out, Please login again to continue.",
      "ORGS_YOU_HAVE_CONFIGURED_WILL_BE_DISPLAYED_HERE": "Orgs you have configured will be displayed here.",
      "CLICK_ON_THE_BUTTON_BELOW_TO_ADD_AN_ORG": "Click on the button below to add an org",
      "APP_CONFIG_UPDATED_SUCCESSFULLY": "App Config Updated Successfully",
      "ORG_CODE_IS_REQUIRED": "Org code is required",
      "ORG_NAME_IS_REQUIRED": "Org name is required",
      "TYPE_IS_REQUIRED": "Type is required",
      "ORG_CREATED_SUCCESSFULLY": "Org Created Successfully",
      "PAYMENT_LINK_ALREADY_GENERATED": "Payment link already generated.",
      "MOBILE_NUMBER_UPDATED": "Mobile Number Updated.",
      "ADD_NEW_NUMBER": "Add New Number.",
      "ARE_YOU_SURE_YOU_WANT_TO_ASSIGN_THE_FULL_PAYMENT_TO_A_0_INVOICE": "Are you sure you want to assign the full payment to a 0 invoice?",
      "UPLOADED_SUCCESSFULLY": "Uploaded Successfully",
      "PAYMENT_TRANSFER_CONFIRMATION_SUCCESSFULLY": "Payment Transfer Confirmation Successfully {{text}}",
      "SUSPENSE_CLEARANCE_CONFIRMATION_SUCCESSFULLY": "Suspense Clearance Confirmation Successfully {{text}}",
      "RECON_CONFIRMATION_SUCCESSFULLY": "Recon Confirmation Successfully {{text}}",
      "PLEASE_ENTER_DIFFERENT_MOBILE_NUMBER": "Please enter different mobile number",
      "YOU_ARE_DEDUCTIONS_PLEASE_CONFIRM": "You are {{text}} deduction(s), Please confirm",
      "THIS_ACTION_IS_NOT_ALLOWED_AS_DUE_POST_AMOUNT_MUST_BE_A_NEGATIVE_VALUE_KINDLY_ADJUST_THE_AMT_TO_ASSIGN": "This action is not allowed, as Due Post Amount must not be a negative value ({{duePostAmt}}). Kindly adjust the Amt To Assign",
      "ARE_YOU_SURE_YOU_WANT_TO_CREATE_BUYER": "Are you sure you want to create buyer?",
      "BUYER_CREATED_SUCCESSFULLY": "Buyer created successfully",
      "INVALID_PASSWORD": "Invalid password",
      "THE_PASSWORD_DO_NOT_MATCH": "The passwords do not match",
      "ARE_YOU_SURE_YOU_WANT_TO_SAVE_THIS_PASSWORD": "Are you sure you want to save this password",
      "FAILED_TO_CREATE_PASSWORD_THE_PASSWORD_CREATION_LINK_HAS_EXPIRED_OR_IS_INVALID": "Failed to create password. The password creation link has expired or is invalid",
      "PLEASE_ENTER_YOUR_CREDENTIALS_TO_ACCESS_THE_DASHBOARD": "Please enter your credentials to access the dashboard",
      "PASSWORD_SUCCESSFULLY_CHANGED": "Password successfully changed",
      "INVALID_JSON_PLEASE_CHECK_FILE_NAME": "Invalid JSON, please check file {{fileName}}",
      "METHOD_NOT_IMPLEMENTED": "Method not implemented.",
      "NO_SAVED_CARDS_FOUND_FOR_SELECTED_SELLER_SELLERNAME": "No saved cards found for selected seller {{sellerName}}.",
      "NO_SAVED_ECHECKS_FOUND_FOR_SELECTED_SELLER_SELLERNAME": "No saved eChecks found for selected seller {{sellerName}}.",
      "SELLER_INVALID_CRED": "You have entered wrong PIN. Please re-enter.",
      "MOBILE_NUMBER_INVALID_MSG": "Sorry, your mobile number is not registered with us. Please contact your Seller or Relationship Manager.",
      "RTP_PAYMENT_REQUEST_FOR_DOC": "A payment request has already been initiated for the document(s) {{docNumber}}.",
      "BUYER_QUEUED_SUCCESSFULLY": "Buyer queued successfully",
      "PAYMETHOD_NOT_VALID_FOR_CURRENCY": "New payment option cannot be added for selected currency.",
      "OUTSTANDING_NO_DATA_FOUND": "No data to be displayed for given range!",
      "NO_DATA_AVAILABLE_FOR_SELECTED_CRITERIA_REVISE_YOUR_SEARCH": "No data available for the selected criteria, please revise your selection and try again.",
      "CALCULATE_SURCHARGE_FAILED": "Failed to calculate Surcharge"
    }
}

export const DYNAMIC_DATA_LABELS = {
    "INV": "LABELS.INV",
    "DN": "LABELS.DN",
    "CN": "LABELS.CN",
    "Invoice": "LABELS.INV",
    "Unknown Payment": "LABELS.UNKNOWN_PAYMENT",
    "Security Deposit": "LABELS.SECURITY_DEPOSIT",
    "Awaiting MIS": "LABELS.AWAITING_MIS",
    "Awaiting": "LABELS.AWAITING",
    "Failed": "LABELS.FAILED",
    "Success": "LABELS.SUCCESS",
    "UNPAID": "LABELS.UNPAID",
    "EXT_SETTLED": "LABELS.EXT_SETTLED",
    "FULLY_PAID": "LABELS.FULLY_PAID",
    "UNUSED": "LABELS.UNUSED",
    "USED": "LABELS.USED",
    "Credit Note date": "LABELS.CREDIT_NOTE_DATE",
    "Amount": "LABELS.AMOUNT",
    "UP": "LABELS.UNKNOWN_PAYMENT",
    "SD": "LABELS.SECURITY_DEPOSIT",
    "Credit Note": "LABELS.CN",
    "Checker Approval Pending": "LABELS.CHECKER_APPROVAL_PENDING",
    "Paid": "LABELS.PAID"
}